import axios from '@/utils/api.request.js'

//   登录
export const doLoginApi = param => {
  const params = {
    Api: 'doLogin',
    Params: param
  }
  return axios.request({
    url: 'login_staffLogin.do',
    data: params
  })
}
//   退出
export const doLogoutApi = param => {
  const params = {
    Api: 'doLogout',
    Params: param
  }
  return axios.request({
    url: 'login_doLogout.do',
    data: params
  })
}
//   获取公司信息
export const getCompanyByIdApi = param => {
  const params = {
    Api: 'getCompanyById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//   品牌列表
export const getBrandListApi = param => {
  const params = {
    Api: 'getBrandList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//   品牌信息
export const getBrandByIdApi = param => {
  const params = {
    Api: 'getBrandById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}

//   门店列表
export const getShopListApi = param => {
  const params = {
    Api: 'getShopList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//   获得角色列表
export const getFunctionTreeByRoleIdApi = param => {
  const params = {
    Params: param
  }
  return axios.request({
    url: 'permission_getFunctionTreeByRoleId.do',
    data: params
  })
}
//   保存角色功能关系
export const setRoleFunctionApi = param => {
  const params = {
    Api: 'setRoleFunction',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
//   获取字典列表信息
export const getDictionaryListApi = param => {
  const params = {
    Api: 'getDictionaryList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}

export const getRoleFunctionListApi = param => {
  const params = {
    Api: 'getRoleFunctionList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
//   获取商品类型列表
export const getGoodsTypeListApi = param => {
  const params = {
    Api: 'getGoodsTypeList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获取所有商品类型列表
export const getAllGoodsTypeListApi = param => {
  const params = {
    Api: 'getAllGoodsTypeList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加商品类型信息
export const addGoodsTypeApi = param => {
  const params = {
    Api: 'addGoodsType',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   根据id获得商品类型信息
export const getGoodsTypeByIdApi = param => {
  const params = {
    Api: 'getGoodsTypeById',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   修改商品类型信息
export const updateGoodsTypeApi = param => {
  const params = {
    Api: 'updateGoodsType',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   设置商品类型信息(修改不空的)
export const setGoodsTypeApi = param => {
  const params = {
    Api: 'setGoodsType',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   删除商品类型信息
export const deleteGoodsTypeApi = param => {
  const params = {
    Api: 'deleteGoodsType',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获取商品详情模板列表信息
export const getGoodsDetailsTemplateListApi = param => {
  const params = {
    Api: 'getGoodsDetailsTemplateList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加商品详情模板信息
export const addGoodsDetailsTemplateApi = param => {
  const params = {
    Api: 'addGoodsDetailsTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   修改商品详情模板信息
export const updateGoodsDetailsTemplateApi = param => {
  const params = {
    Api: 'updateGoodsDetailsTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   根据id获得商品详情模板信息
export const getGoodsDetailsTemplateByIdApi = param => {
  const params = {
    Api: 'getGoodsDetailsTemplateById',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   删除商品详情模板信息
export const deleteGoodsDetailsTemplateApi = param => {
  const params = {
    Api: 'deleteGoodsDetailsTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获取商品标签列表信息
export const getGoodsTagListApi = param => {
  const params = {
    Api: 'getGoodsTagList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加商品标签
export const addGoodsTagApi = param => {
  const params = {
    Api: 'addGoodsTag',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   删除商品标签
export const deleteGoodsTagApi = param => {
  const params = {
    Api: 'deleteGoodsTag',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加商品信息
export const addGoodsApi = param => {
  const params = {
    Api: 'addGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   修改商品信息
export const updateGoodsApi = param => {
  const params = {
    Api: 'updateGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获得商品详细信息
export const getGoodsDetailApi = param => {
  const params = {
    Api: 'getGoodsDetail',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获取商品列表信息
export const getGoodsListApi = param => {
  const params = {
    Api: 'getGoodsList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加商品属性和条目
export const addGoodsPropertyAndItemApi = param => {
  const params = {
    Api: 'addGoodsPropertyAndItem',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   更新商品属性和条目
export const updateGoodsPropertyAndItemApi = param => {
  const params = {
    Api: 'updateGoodsPropertyAndItem',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加商品sku信息
export const addGoodsSkuApi = param => {
  const params = {
    Api: 'addGoodsSku',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   删除商品属性条目
export const deleteGoodsPropertyItemApi = param => {
  const params = {
    Api: 'deleteGoodsPropertyItem',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   删除商品属性信息
export const deleteGoodsPropertyApi = param => {
  const params = {
    Api: 'deleteGoodsProperty',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获取商品关联的属性和条目及sku相关信息列表
export const getGoodsPropertyAndItemAndSkuListApi = param => {
  const params = {
    Api: 'getGoodsPropertyAndItemAndSkuList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加商品搭售分组
export const addGoodsRelationGroupApi = param => {
  const params = {
    Api: 'addGoodsRelationGroup',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   修改商品搭售分组
export const updateGoodsRelationGroupApi = param => {
  const params = {
    Api: 'updateGoodsRelationGroup',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获取商品搭售分组
export const getGoodsRelationGroupApi = param => {
  const params = {
    Api: 'getGoodsRelationGroup',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   删除商品搭售分组
export const deleteGoodsRelationGroupApi = param => {
  const params = {
    Api: 'deleteGoodsRelationGroup',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加商品搭售关联配置
export const addGoodsRelationConfigApi = param => {
  const params = {
    Api: 'addGoodsRelationConfig',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   修改商品搭售关联配置
export const updateGoodsRelationConfigApi = param => {
  const params = {
    Api: 'updateGoodsRelationConfig',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   根据detailId获取商品搭售关联配置详情
export const getGoodsRelationConfigDetailByIdApi = param => {
  const params = {
    Api: 'getGoodsRelationConfigDetailById',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   保存商品搭售关联配置vip价格
export const saveGoodsRelationConfigVipPriceApi = param => {
  const params = {
    Api: 'saveGoodsRelationConfigVipPrice',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   删除商品搭售关联配置
export const deleteGoodsRelationConfigApi = param => {
  const params = {
    Api: 'deleteGoodsRelationConfig',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   批量设置商品虚拟销量
export const batchSetGoodsVirtualSalesNumApi = param => {
  const params = {
    Api: 'batchSetGoodsVirtualSalesNum',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   设置商品是否上架
export const setGoodsIsShelvesApi = param => {
  const params = {
    Api: 'setGoodsIsShelves',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   批量设置商品是否上架
export const batchSetGoodsIsShelvesApi = param => {
  const params = {
    Api: 'batchSetGoodsIsShelves',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   批量设置商品sku信息
export const batchSetGoodsSkuApi = param => {
  const params = {
    Api: 'batchSetGoodsSku',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   设置商品图片
export const setGoodsPicContentApi = param => {
  const params = {
    Api: 'setGoodsPicContent',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   设置商品图片
export const queryGoodsApi = param => {
  const params = {
    Api: 'queryGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   更新商品sku接口
export const updateGoodsSkuApi = param => {
  const params = {
    Api: 'updateGoodsSku',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获取品牌下门店列表所在城市
export const getShopCityListByBrandIdApi = param => {
  const params = {
    Api: 'getShopCityListByBrandId',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//   获取品牌下门店列表
export const queryShopApi = param => {
  const params = {
    Api: 'queryShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//   获取商品搭售分组和对应配置统计列表
export const getGoodsRelationGroupAndConfigCountListApi = param => {
  const params = {
    Api: 'getGoodsRelationGroupAndConfigCountList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获取商品搭售关联配置详情列表
export const getGoodsRelationConfigDetailListApi = param => {
  const params = {
    Api: 'getGoodsRelationConfigDetailList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   查询商品标签信息
export const queryGoodsTagApi = param => {
  const params = {
    Api: 'queryGoodsTag',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}

//   查询商品详情模板信息
export const queryGoodsDetailsTemplateApi = param => {
  const params = {
    Api: 'queryGoodsDetailsTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   获取商品搭售分组列表
export const getGoodsRelationGroupListApi = param => {
  const params = {
    Api: 'getGoodsRelationGroupList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加商品搭售分组关联
export const addGoodsRelationGroupRelApi = param => {
  const params = {
    Api: 'addGoodsRelationGroupRel',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   删除商品搭售分组关联
export const deleteGoodsRelationGroupRelApi = param => {
  const params = {
    Api: 'deleteGoodsRelationGroupRel',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//   添加图片类型信息
export const addPicTypeApi = param => {
  const params = {
    Api: 'addPicType',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
//   修改图片类型信息
export const updatePicTypeApi = param => {
  const params = {
    Api: 'updatePicType',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
//   获取图片类型列表信息
export const getPicTypeListApi = param => {
  const params = {
    Api: 'getPicTypeList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
//   添加图库信息
export const addPicLibApi = param => {
  const params = {
    Api: 'addPicLib',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
//   删除图库信息
export const deletePicLibApi = param => {
  const params = {
    Api: 'deletePicLib',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
//   查询图库信息
export const queryPicLibApi = param => {
  const params = {
    Api: 'queryPicLib',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}

// *********************************************员工************************************************
//   查询员工列表信息接口
export const queryStaffApi = param => {
  const params = {
    Api: 'queryStaff',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}

//   查询员工列表信息接口
export const getRoleListApi = param => {
  const params = {
    Api: 'getRoleList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}

//   添加角色信息
export const addRoleApi = param => {
  const params = {
    Api: 'addRole',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}

// 修改角色信息
export const updateRoleApi = param => {
  const params = {
    Api: 'updateRole',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}

// 根据id获得角色信息
export const getRoleByIdApi = param => {
  const params = {
    Api: 'getRoleById',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 根据id获得角色信息
export const deleteRoleApi = param => {
  const params = {
    Api: 'deleteRole',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 添加员工信息
export const addStaffApi = param => {
  const params = {
    Api: 'addStaff',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 修改员工信息
export const updateStaffApi = param => {
  const params = {
    Api: 'updateStaff',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 获取员工详情
export const getStaffByIdApi = param => {
  const params = {
    Api: 'getStaffById',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 保存支付挂账渠道信息
export const addBillChannelApi = param => {
  const params = {
    Api: 'addBillChannel',
    Params: param
  }
  return axios.request({
    url: 'pay_callApi.do',
    data: params
  })
}
// 删除支付挂账渠道信息
export const deleteBillChannelApi = param => {
  const params = {
    Api: 'deleteBillChannel',
    Params: param
  }
  return axios.request({
    url: 'pay_callApi.do',
    data: params
  })
}
// 获取支付渠道列表
export const getBillChannelListApi = param => {
  const params = {
    Api: 'getBillChannelList',
    Params: param
  }
  return axios.request({
    url: 'pay_callApi.do',
    data: params
  })
}
// 批量设置品牌相关配置
export const batchSetBrandRelConfigApi = param => {
  const params = {
    Api: 'batchSetBrandRelConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置门店信息
export const setShopMsgApi = param => {
  const params = {
    Api: 'setShopMsg',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取门店信息
export const getShopApi = param => {
  const params = {
    Api: 'getShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取门店区域信息
export const getTableAreaListApi = param => {
  const params = {
    Api: 'getTableAreaList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取门店桌号列表信息
export const getDeskCardListApi = param => {
  const params = {
    Api: 'getDeskCardList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 保存餐台区域
export const addTableAreaApi = param => {
  const params = {
    Api: 'addTableArea',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改餐台区域
export const updateTableAreaApi = param => {
  const params = {
    Api: 'updateTableArea',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 保存桌号
export const deleteTableAreaApi = param => {
  const params = {
    Api: 'deleteTableArea',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 保存桌号
export const saveDeskCardApi = param => {
  const params = {
    Api: 'saveDeskCard',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除桌号（台号）
export const deleteDeskCardApi = param => {
  const params = {
    Api: 'deleteDeskCard',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 桌牌号批量排序
export const deskCardBatchSortApi = param => {
  const params = {
    Api: 'deskCardBatchSort',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询快递配置详情列表
export const queryExpressTemplateListApi = param => {
  const params = {
    Api: 'queryExpressTemplateList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询快递配置对应id的详情信息
export const queryExpressTemplateByIdApi = param => {
  const params = {
    Api: 'queryExpressTemplateById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改快递配置为默认
export const updateExpressTemplateIsDefaultApi = param => {
  const params = {
    Api: 'updateExpressTemplateIsDefault',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改快递配置
export const updateExpressTemplateApi = param => {
  const params = {
    Api: 'updateExpressTemplate',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除快递配置
export const deleteExpressTemplateApi = param => {
  const params = {
    Api: 'deleteExpressTemplate',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加快递配置
export const addExpressTemplateApi = param => {
  const params = {
    Api: 'addExpressTemplate',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 城市信息
export const getDistrictListApi = param => {
  const params = {
    Api: 'getDistrictList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 获得备注列表信息
export const getGoodsRemarkListApi = param => {
  const params = {
    Api: 'getGoodsRemarkList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加备注信息
export const addGoodsRemarkApi = param => {
  const params = {
    Api: 'addGoodsRemark',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除备注信息
export const deleteGoodsRemarkApi = param => {
  const params = {
    Api: 'deleteGoodsRemark',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询优惠券列表
export const queryTicketApi = param => {
  const params = {
    Api: 'queryTicket',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加优惠券
export const addTicketApi = param => {
  const params = {
    Api: 'addTicket',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据优惠券id查询优惠券
export const getTicketByIdApi = param => {
  const params = {
    Api: 'getTicketById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 修改优惠券信息
export const updateTicketApi = param => {
  const params = {
    Api: 'updateTicket',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 作废电子券
export const setTicketCancelOrHideApi = param => {
  const params = {
    Api: 'setTicketCancelOrHide',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 同步微信卡券
export const createWechatCardTicketApi = param => {
  const params = {
    Api: 'createWechatCardTicket',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询导出电子券信息
export const queryExportRecordApi = param => {
  const params = {
    Api: 'queryExportRecord',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 分页查询会员等级信息
export const queryGradeApi = param => {
  const params = {
    Api: 'queryGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 新增会员等级信息
export const addGradeApi = param => {
  const params = {
    Api: 'addGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 修改会等级信息
export const updateGradeApi = param => {
  const params = {
    Api: 'updateGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 删除会员等级
export const deleteUserGradeApi = param => {
  const params = {
    Api: 'deleteUserGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 会员等级切换等级
export const changeBrandUserGradeApi = param => {
  const params = {
    Api: 'changeBrandUserGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 会员等级设置启用
export const enableGradeApi = param => {
  const params = {
    Api: 'enableGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 会员等级设置停止
export const disableGradeApi = param => {
  const params = {
    Api: 'disableGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询会员分页
export const queryUserApi = param => {
  const params = {
    Api: 'queryUser',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 添加品牌用户标签信息
export const addBrandUserTagApi = param => {
  const params = {
    Api: 'addBrandUserTag',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 修改品牌用户标签信息
export const updateBrandUserTagApi = param => {
  const params = {
    Api: 'updateBrandUserTag',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据id获取品牌用户标签信息
export const getBrandUserTagByIdApi = param => {
  const params = {
    Api: 'getBrandUserTagById',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 删除品牌用户标签信息
export const deleteBrandUserTagApi = param => {
  const params = {
    Api: 'deleteBrandUserTag',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询品牌用户标签列表信息
export const queryBrandUserTagApi = param => {
  const params = {
    Api: 'queryBrandUserTag',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 添加会员信息
export const addUserApi = param => {
  const params = {
    Api: 'addUser',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 修改会员信息
export const updateUserApi = param => {
  const params = {
    Api: 'updateUser',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 获取会员详情信息
export const getBrandUserByIdApi = param => {
  const params = {
    Api: 'getBrandUserById',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 订单流水
export const queryOrderWaterApi = param => {
  const params = {
    Api: 'queryOrderWater',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 获取用户电子券统计(支持通用券)
export const getTicketUseCountApi = param => {
  const params = {
    Api: 'getTicketUseCount',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置会员状态
export const setBrandUserByIdApi = param => {
  const params = {
    Api: 'setBrandUserById',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置会员拓展信息
export const setUserExtendConfigApi = param => {
  const params = {
    Api: 'setUserExtendConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询营销活动列表
export const queryMarketingActivityApi = param => {
  const params = {
    Api: 'queryMarketingActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加营销活动
export const addMarketingActivityApi = param => {
  const params = {
    Api: 'addMarketingActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 修改营销活动
export const updateMarketingActivityApi = param => {
  const params = {
    Api: 'updateMarketingActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 删除营销活动
export const deleteMarketingActivityApi = param => {
  const params = {
    Api: 'deleteMarketingActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置营销活动状态
export const setMarketingActivityStateApi = param => {
  const params = {
    Api: 'setMarketingActivityState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id查询营销活动信息
export const getMarketingActivityByIdApi = param => {
  const params = {
    Api: 'getMarketingActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 调账
export const accountAdjustmentApi = param => {
  const params = {
    Api: 'accountAdjustment',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 调积分
export const integralAdjustmentApi = param => {
  const params = {
    Api: 'integralAdjustment',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置营销活动排序
export const setMarketingActivitySortApi = param => {
  const params = {
    Api: 'setMarketingActivitySort',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 商家首页信息
export const queryBusinessHomePageApi = param => {
  const params = {
    Api: 'queryBusinessHomePage',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询用户的消费记录
export const queryUserPurchaseHistoryApi = param => {
  const params = {
    Api: 'queryUserPurchaseHistory',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询活动信息
export const queryActivityMessageApi = param => {
  const params = {
    Api: 'queryActivityMessage',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询会员拥有的优惠券
export const getBrandUserTicketListApi = param => {
  const params = {
    Api: 'getBrandUserTicketList',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 会员调券——增加
export const adjustTicketForAddApi = param => {
  const params = {
    Api: 'adjustTicketForAdd',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 会员调券——扣除
export const adjustTicketForReduceApi = param => {
  const params = {
    Api: 'adjustTicketForReduce',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 会员账户流水
export const queryUserAccountWaterApi = param => {
  const params = {
    Api: 'queryUserAccountWater',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 会员统计
export const queryOtherOrderListApi = param => {
  const params = {
    Api: 'queryOtherOrderList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 获取品牌用户标签关联列表
export const getBrandUserTagRelListApi = param => {
  const params = {
    Api: 'getBrandUserTagRelList',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 保存品牌用户标签关联
export const saveBrandUserTagRelApi = param => {
  const params = {
    Api: 'saveBrandUserTagRel',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 批量添加品牌用户标签关联
export const batchAddBrandUserTagRelApi = param => {
  const params = {
    Api: 'batchAddBrandUserTagRel',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据id获取导入记录信息
export const getBusinessOpporImportByIdApi = param => {
  const params = {
    Api: 'getBusinessOpporImportById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 分页查询制卡记录
export const queryCardMakeRecordApi = param => {
  const params = {
    Api: 'queryCardMakeRecord',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 制作卡
export const addCardsApi = param => {
  const params = {
    Api: 'addCards',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据id获取制卡记录详情
export const getCardMakeRecordBeanByIdApi = param => {
  const params = {
    Api: 'getCardMakeRecordBeanById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置员工状态
export const setStaffApi = param => {
  const params = {
    Api: 'setStaff',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 设置员工状态
export const deleteStaffApi = param => {
  const params = {
    Api: 'deleteStaff',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 商品类型排序
export const setGoodsTypeSortNumApi = param => {
  const params = {
    Api: 'setGoodsTypeSortNum',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 更改门店的shopRadionConifg
export const updateShopRadioConfigApi = param => {
  const params = {
    Api: 'updateShopRadioConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询门店设备列表
export const queryShopDeviceListApi = param => {
  const params = {
    Api: 'queryShopDeviceList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加门店设备
export const addShopDeviceApi = param => {
  const params = {
    Api: 'addShopDevice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新门店设备
export const updateShopDeviceApi = param => {
  const params = {
    Api: 'updateShopDevice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除门店设备
export const deleteShopDeviceApi = param => {
  const params = {
    Api: 'deleteShopDevice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询打印机列表
export const queryPrinterConfigApi = param => {
  const params = {
    Api: 'queryPrinterConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加打印机
export const addPrinterConfigApi = param => {
  const params = {
    Api: 'addPrinterConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除打印机
export const deletePrinterConfigApi = param => {
  const params = {
    Api: 'deletePrinterConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改打印机
export const updatePrinterConfigApi = param => {
  const params = {
    Api: 'updatePrinterConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id获得打印机信息
export const getPrinterConfigByIdApi = param => {
  const params = {
    Api: 'getPrinterConfigById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 打印测试
export const printerTestApi = param => {
  const params = {
    Api: 'printerTest',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取指定门店配送设置列表
export const getFreightListApi = param => {
  const params = {
    Api: 'getFreightList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 新增/更新配送信息
export const saveOrUpdateFreightApi = param => {
  const params = {
    Api: 'saveOrUpdateFreight',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除同城配送信息
export const deleteFreightApi = param => {
  const params = {
    Api: 'deleteFreight',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加达达申请账号
export const addDadaBrandApi = param => {
  const params = {
    Api: 'addBrand',
    Params: param
  }
  return axios.request({
    url: 'dada_callApi.do',
    data: params
  })
}
// 添加达达申请门店
export const addDadaShopApi = param => {
  const params = {
    Api: 'addShop',
    Params: param
  }
  return axios.request({
    url: 'dada_callApi.do',
    data: params
  })
}
// 绑定达达门店
export const bindDadaShopApi = param => {
  const params = {
    Api: 'bindShop',
    Params: param
  }
  return axios.request({
    url: 'dada_callApi.do',
    data: params
  })
}
// 小票打印机配置
export const setPrinterUniversalConfigApi = param => {
  const params = {
    Api: 'setPrinterUniversalConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取小票打印机配置
export const getPrinterUniversalConfigApi = param => {
  const params = {
    Api: 'getPrinterUniversalConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询订单管理
export const queryOrderCollectionApi = param => {
  const params = {
    Api: 'queryOrderCollection',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询退款/退货详情
export const queryOrderRefundDetailApi = param => {
  const params = {
    Api: 'queryOrderRefundDetail',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 根据id获得公司相关信息(用于商家平台)
export const getCompanyForPlatformByIdApi = param => {
  const params = {
    Api: 'getCompanyForPlatformById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询品牌信息(用于商家平台)
export const queryBrandForPlatformApi = param => {
  const params = {
    Api: 'queryBrandForPlatform',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 1、新增品牌类型addBrandCategory
// 2、更新品牌类型updateBrandCategory
// 3、查询品牌类型queryBrandCategory
// 4、设置品牌的分类setCategoryByBrandId
// 新增品牌类型
export const addBrandCategoryApi = param => {
  const params = {
    Api: 'addBrandCategory',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新品牌类型
export const updateBrandCategoryApi = param => {
  const params = {
    Api: 'updateBrandCategory',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询品牌类型
export const queryBrandCategoryApi = param => {
  const params = {
    Api: 'queryBrandCategory',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置品牌的分类
export const setCategoryByBrandIdApi = param => {
  const params = {
    Api: 'setCategoryByBrandId',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询短信记录
export const querySmsHistoryApi = param => {
  const params = {
    Api: 'querySmsHistory',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询短信模板
export const querySmsTemplateApi = param => {
  const params = {
    Api: 'querySmsTemplate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 添加短信模板
export const addSmsTemplateApi = param => {
  const params = {
    Api: 'addSmsTemplate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 修改短信模板
export const updateSmsTemplateApi = param => {
  const params = {
    Api: 'updateSmsTemplate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 设置短信模板
export const setSmsTemplateApi = param => {
  const params = {
    Api: 'setSmsTemplate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 删除短信模板
export const deleteSmsTemplateApi = param => {
  const params = {
    Api: 'deleteSmsTemplate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 根据电子券id查询电子券
export const queryTicketByIdsApi = param => {
  const params = {
    Api: 'queryTicketByIds',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 同意退款
export const acceptRefundApi = param => {
  const params = {
    Api: 'acceptRefund',
    Params: param
  }
  return axios.request({
    url: 'pay_callApi.do',
    data: params
  })
}
// 拒绝退款
export const refuseRefundApi = param => {
  const params = {
    Api: 'refuseRefund',
    Params: param
  }
  return axios.request({
    url: 'pay_callApi.do',
    data: params
  })
}
// 商品统计
export const queryOrderGoodsOverviewApi = param => {
  const params = {
    Api: 'queryOrderGoodsOverview',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询店间结算
export const queryShopSettlementApi = param => {
  const params = {
    Api: 'queryShopSettlement',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 获取已被删除的支付渠道列表
export const getDeleteBillChannelListApi = param => {
  const params = {
    Api: 'getDeleteBillChannelList',
    Params: param
  }
  return axios.request({
    url: 'pay_callApi.do',
    data: params
  })
}
// 查询订单流水合计
export const queryOrderWaterTotalApi = param => {
  const params = {
    Api: 'queryOrderWaterTotal',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 营业统计合计
export const queryBusinessWithTotalApi = param => {
  const params = {
    Api: 'queryBusinessWithTotal',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 营业统计按日月
export const queryBusinessWithDayApi = param => {
  const params = {
    Api: 'queryBusinessWithDay',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 汇总合计
export const queryMemberStatisticsApi = param => {
  const params = {
    Api: 'queryMemberStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 汇总按日月
export const queryMemberStatisticsWithDayApi = param => {
  const params = {
    Api: 'queryMemberStatisticsWithDay',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 充值收入汇总
export const queryRechargeStatisticsApi = param => {
  const params = {
    Api: 'queryRechargeStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 充值收入按日月
export const queryRechargeStatisticsWithDayApi = param => {
  const params = {
    Api: 'queryRechargeStatisticsWithDay',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 充值\调账明细
export const queryRechargeAdjustmentListApi = param => {
  const params = {
    Api: 'queryRechargeAdjustmentList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 购卡汇总
export const querySaleCardStatisticsApi = param => {
  const params = {
    Api: 'querySaleCardStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 购卡按日月
export const querySaleCardStatisticsWithDayApi = param => {
  const params = {
    Api: 'querySaleCardStatisticsWithDay',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 购卡详情
export const querySaleCardListApi = param => {
  const params = {
    Api: 'querySaleCardList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 积分汇总
export const queryJFStatisticsApi = param => {
  const params = {
    Api: 'queryJFStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 积分按日月
export const queryJFStatisticsWithDayApi = param => {
  const params = {
    Api: 'queryJFStatisticsWithDay',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 积分详情列表
export const queryIntegralDetailListApi = param => {
  const params = {
    Api: 'queryIntegralDetailList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 优惠券详情列表
export const queryYHQDetailListApi = param => {
  const params = {
    Api: 'queryYHQDetailList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 优惠券门店详情列表
export const queryYHQShopDetailListApi = param => {
  const params = {
    Api: 'queryYHQShopDetailList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 优惠券订单详情列表
export const queryYHQOrderDetailListApi = param => {
  const params = {
    Api: 'queryYHQOrderDetailList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 调账汇总
export const queryTZStatisticsApi = param => {
  const params = {
    Api: 'queryTZStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 调账按日月
export const queryTZStatisticsWithDayApi = param => {
  const params = {
    Api: 'queryTZStatisticsWithDay',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 调券按日月
export const queryTQStatisticsWithDayApi = param => {
  const params = {
    Api: 'queryTQStatisticsWithDay',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 调券明细
export const queryCouponDetailListApi = param => {
  const params = {
    Api: 'queryCouponDetailList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 员工密码重置
export const resetStaffPasswordApi = param => {
  const params = {
    Api: 'resetStaffPassword',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 优惠券使用详情
export const queryYHQDetailApi = param => {
  const params = {
    Api: 'queryYHQDetail',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 分销活动分页查询
export const queryDistributionActivityApi = param => {
  const params = {
    Api: 'queryDistributionActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 新增/更新分销活动
export const saveOrUpdateDistributionActivityApi = param => {
  const params = {
    Api: 'saveOrUpdateDistributionActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id获取分销活动详情
export const getDistributionActivityByIdApi = param => {
  const params = {
    Api: 'getDistributionActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取每个人参与分销活动的收益报表
export const getDistributionActivityPersonalReportApi = param => {
  const params = {
    Api: 'getDistributionActivityPersonalReport',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取分销订单信息
export const getDistributionActivityOrdersApi = param => {
  const params = {
    Api: 'getDistributionActivityOrders',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更改分销活动状态
export const updateDistributionActivityStateApi = param => {
  const params = {
    Api: 'updateDistributionActivityState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更改品牌的logo
export const updateBaseBrandApi = param => {
  const params = {
    Api: 'updateBaseBrand',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置品牌信息
export const setBrandMsgApi = param => {
  const params = {
    Api: 'setBrandMsg',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新设置品牌信息
export const updateBrandApi = param => {
  const params = {
    Api: 'updateBrand',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置余额支付短信验证码
export const updateBalanceUseValiCodeApi = param => {
  const params = {
    Api: 'updateBalanceUseValiCode',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置品牌config
export const setBrandConfigApi = param => {
  const params = {
    Api: 'setBrandConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取导出卡信息
export const getExportRecordIdInfoApi = param => {
  const params = {
    Api: 'getExportRecordIdInfo',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据条件获取微信账号信息
export const getWechatAccountByConditApi = param => {
  const params = {
    Api: 'getWechatAccountByCondit',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 上传网络图片到微信
export const upPicUrlToWeChatApi = param => {
  const params = {
    Api: 'upPicUrlToWeChat',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 添加微信卡信息
export const addWechatCardApi = param => {
  const params = {
    Api: 'addWechatCard',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 更新微信卡信息
export const updateWechatCardApi = param => {
  const params = {
    Api: 'updateWechatCard',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 根据条件查询微信卡信息
export const getWechatCardByConditApi = param => {
  const params = {
    Api: 'getWechatCardByCondit',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 查询微助力活动
export const queryZlchbActivityApi = param => {
  const params = {
    Api: 'queryZlchbActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更改活动状态——微助力活动
export const updateZlchbStateApi = param => {
  const params = {
    Api: 'updateZlchbState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 新增微助力活动
export const saveOrUpdateZlchbActivityApi = param => {
  const params = {
    Api: 'saveOrUpdateZlchbActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 助力者进行助力
export const openZlchbApi = param => {
  const params = {
    Api: 'openZlchb',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取公众号和小程序信息
export const getWechatAccountListApi = param => {
  const params = {
    Api: 'getWechatAccountList',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 获取消息推送和消息模板列表
export const getPushModeAndMsgModeListApi = param => {
  const params = {
    Api: 'getPushModeAndMsgModeList',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 设置消息模板信息
export const setMsgModeApi = param => {
  const params = {
    Api: 'setMsgMode',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 添加微信通知绑定
export const addWechatNoticeBindApi = param => {
  const params = {
    Api: 'addWechatNoticeBind',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 删除微信通知绑定
export const deleteWechatNoticeBindApi = param => {
  const params = {
    Api: 'deleteWechatNoticeBind',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 获取微信通知绑定列表信息
export const getWechatNoticeBindListApi = param => {
  const params = {
    Api: 'getWechatNoticeBindList',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 获取会员卡信息
export const getBrandUserCardListApi = param => {
  const params = {
    Api: 'getBrandUserCardList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取微助力活动详情
export const getZlchbActivityByIdApi = param => {
  const params = {
    Api: 'getZlchbActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 保存sku图片编号
export const saveSkuPicApi = param => {
  const params = {
    Api: 'saveSkuPic',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 添加次卡活动
export const addSubCardActivityApi = param => {
  const params = {
    Api: 'addSubCardActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更新次卡活动
export const updateSubCardActivityApi = param => {
  const params = {
    Api: 'updateSubCardActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询卡使用流水
export const queryCardUseWaterApi = param => {
  const params = {
    Api: 'queryCardUseWater',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 绑定门店相关快递鸟信息
export const bindShopForKdNiaoApi = param => {
  const params = {
    Api: 'bindShopForKdNiao',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 添加电子面单模板
export const addElectronicSheetTemplateApi = param => {
  const params = {
    Api: 'addElectronicSheetTemplate',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 修改电子面单模板
export const updateElectronicSheetTemplateApi = param => {
  const params = {
    Api: 'updateElectronicSheetTemplate',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 删除电子面单模板
export const deleteElectronicSheetTemplateApi = param => {
  const params = {
    Api: 'deleteElectronicSheetTemplate',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 修改电子面单模板为默认
export const updateElectronicSheetTemplateIsDefaultApi = param => {
  const params = {
    Api: 'updateElectronicSheetTemplateIsDefault',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询电子面单模板列表
export const queryElectronicSheetTemplateListApi = param => {
  const params = {
    Api: 'queryElectronicSheetTemplateList',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询电子面单模板对应id的详情信息
export const queryElectronicSheetTemplateByIdApi = param => {
  const params = {
    Api: 'queryElectronicSheetTemplateById',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询电子面单相关的订单列表信息
export const queryElectronicSheetOrderListApi = param => {
  const params = {
    Api: 'queryElectronicSheetOrderList',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 获取打印电子面单相关参数
export const queryElectronicSheetPrintOrderApi = param => {
  const params = {
    Api: 'queryElectronicSheetPrintOrder',
    Params: param
  }
  return axios.request({
    url: 'order_queryElectronicSheetPrintOrder.do',
    data: params
  })
}
// 快递鸟电子面单
export const orderOnlineKdNiaoApi = param => {
  const params = {
    Api: 'orderOnlineKdNiao',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 调整关系
export const updateRelationshipApi = param => {
  const params = {
    Api: 'updateRelationship',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查看品牌是否有人参与分销
export const anyoneJoinedInApi = param => {
  const params = {
    Api: 'anyoneJoinedIn',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据电话号码查询分销信息
export const getDistribtuionMsgByTelApi = param => {
  const params = {
    Api: 'getDistribtuionMsgByTel',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 领券中心列表查询
export const queryTicketCenterApi = param => {
  const params = {
    Api: 'queryTicketCenter',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 修改领券中心活动状态
export const updateTicketCenterStateApi = param => {
  const params = {
    Api: 'updateTicketCenterState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 创建领券中心活动
export const addTicketCenterActivityApi = param => {
  const params = {
    Api: 'addTicketCenterActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 修改领券中心活动
export const updateTicketCenterActivityApi = param => {
  const params = {
    Api: 'updateTicketCenterActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取活动中心详情
export const getTicketCenterDetailApi = param => {
  const params = {
    Api: 'getTicketCenterDetail',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询签到活动列表
export const querySignActivityApi = param => {
  const params = {
    Api: 'querySignActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更新签到活动状态
export const updateSignStateApi = param => {
  const params = {
    Api: 'updateSignState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 新增签到活动
export const addSignActivityApi = param => {
  const params = {
    Api: 'addSignActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更新签到活动
export const updateSignActivityApi = param => {
  const params = {
    Api: 'updateSignActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id获取签到活动详情
export const getSignActivityByIdApi = param => {
  const params = {
    Api: 'getSignActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加预约项目类型信息
export const addReserveProjectTypeApi = param => {
  const params = {
    Api: 'addReserveProjectType',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除预约项目类型信息
export const deleteReserveProjectTypeApi = param => {
  const params = {
    Api: 'deleteReserveProjectType',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改预约项目类型信息
export const updateReserveProjectTypeApi = param => {
  const params = {
    Api: 'updateReserveProjectType',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取预约项目类型列表信息
export const getReserveProjectTypeListApi = param => {
  const params = {
    Api: 'getReserveProjectTypeList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加预约项目标签信息
export const addReserveProjectTagApi = param => {
  const params = {
    Api: 'addReserveProjectTag',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除预约项目标签信息
export const deleteReserveProjectTagApi = param => {
  const params = {
    Api: 'deleteReserveProjectTag',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改预约项目标签信息
export const updateReserveProjectTagApi = param => {
  const params = {
    Api: 'updateReserveProjectTag',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取预约项目标签列表信息
export const getReserveProjectTagListApi = param => {
  const params = {
    Api: 'getReserveProjectTagList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询预约项目标签列表信息
export const queryReserveProjectTagApi = param => {
  const params = {
    Api: 'queryReserveProjectTag',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加预约项目
export const addReserveProjectApi = param => {
  const params = {
    Api: 'addReserveProject',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改预约项目
export const updateReserveProjectApi = param => {
  const params = {
    Api: 'updateReserveProject',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置预约项目状态
export const setReserveProjectStateApi = param => {
  const params = {
    Api: 'setReserveProjectState',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询预约项目列表
export const queryReserveProjectListApi = param => {
  const params = {
    Api: 'queryReserveProjectList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id查询预约项目
export const getReserveProjectByIdApi = param => {
  const params = {
    Api: 'getReserveProjectById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更改满额减免活动状态
export const updateMejmStateApi = param => {
  const params = {
    Api: 'updateMejmState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}

//   export default

/** *************************** xsd start ************************** **/
// 限时折扣商品
export const queryActivityGoodsApi = param => {
  const params = {
    Api: 'queryActivityGoods',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const addActivityGoodsApi = param => {
  const params = {
    Api: 'addActivityGoods',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const updateActivityGoodsApi = param => {
  const params = {
    Api: 'updateActivityGoods',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const getActivityGoodsByIdApi = param => {
  const params = {
    Api: 'getActivityGoodsById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 礼包卡
export const queryGiftCardActivityApi = param => {
  const params = {
    Api: 'queryGiftCardActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const addGiftCardActivityApi = param => {
  const params = {
    Api: 'addGiftCardActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const updateGiftCardActivityApi = param => {
  const params = {
    Api: 'updateGiftCardActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const getGiftCardActivityByIdApi = param => {
  const params = {
    Api: 'getGiftCardActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const deleteGiftCardActivityApi = param => {
  const params = {
    Api: 'deleteGiftCardActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}

// 储值营销
export const queryRechargeActivityApi = param => {
  const params = {
    Api: 'queryRechargeActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const addRechargeActivityApi = param => {
  const params = {
    Api: 'addRechargeActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const updateRechargeActivityApi = param => {
  const params = {
    Api: 'updateRechargeActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const updateRechargeStateApi = param => {
  const params = {
    Api: 'updateRechargeState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const getRechargeActivityByIdApi = param => {
  const params = {
    Api: 'getRechargeActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 等级卡(权益卡)
export const addGradeActivityApi = param => {
  const params = {
    Api: 'addGradeActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const updateGradeActivityApi = param => {
  const params = {
    Api: 'updateGradeActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const getGradeActivityByIdApi = param => {
  const params = {
    Api: 'getGradeActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const queryGradeActivityApi = param => {
  const params = {
    Api: 'queryGradeActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const deleteGradeActivityApi = param => {
  const params = {
    Api: 'deleteGradeActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 积分商品
export const addIntegralActivityApi = param => {
  const params = {
    Api: 'addIntegralActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const updateIntegralActivityApi = param => {
  const params = {
    Api: 'updateIntegralActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const getIntegralActivityByIdApi = param => {
  const params = {
    Api: 'getIntegralActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const queryIntegralActivityApi = param => {
  const params = {
    Api: 'queryIntegralActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const updateIntegralStateApi = param => {
  const params = {
    Api: 'updateIntegralState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 买赠(买N赠N)
export const addBuyGiftsActivityApi = param => {
  const params = {
    Api: 'addBuyGiftsActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
export const updateBuyGiftsActivityApi = param => {
  const params = {
    Api: 'updateBuyGiftsActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 新增/更新表单
export const saveOrUpdateFormTableApi = param => {
  const params = {
    Api: 'saveOrUpdateFormTable',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 表单列表
export const queryFormTableApi = param => {
  const params = {
    Api: 'queryFormTable',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置表单状态
export const updateFormTableStateApi = param => {
  const params = {
    Api: 'updateFormTableState',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询参与抽奖活动列表信息
export const queryMarketingActivityPrizePartakeListApi = param => {
  const params = {
    Api: 'queryMarketingActivityPrizePartakeList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 拼团 新增/更新
export const saveOrUpdateGroupActivityApi = param => {
  const params = {
    Api: 'saveOrUpdateGroupActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 拼团 根据id获取详情
export const getGroupActivityByIdApi = param => {
  const params = {
    Api: 'getGroupActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 拼团 分页查询
export const queryGroupActivityApi = param => {
  const params = {
    Api: 'queryGroupActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 拼团 更改订单状态
export const updateGroupActivityStateApi = param => {
  const params = {
    Api: 'updateGroupActivityState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加服务员分组信息
export const addWaiterGroupApi = param => {
  const params = {
    Api: 'addWaiterGroup',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 删除服务员分组信息
export const deleteWaiterGroupApi = param => {
  const params = {
    Api: 'deleteWaiterGroup',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 修改服务员分组信息
export const updateWaiterGroupApi = param => {
  const params = {
    Api: 'updateWaiterGroup',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 修改服务员分组信息
export const getWaiterGroupListApi = param => {
  const params = {
    Api: 'getWaiterGroupList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 添加服务员信息
export const addWaiterApi = param => {
  const params = {
    Api: 'addWaiter',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 删除服务员信息
export const deleteWaiterApi = param => {
  const params = {
    Api: 'deleteWaiter',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 修改服务员信息
export const updateWaiterApi = param => {
  const params = {
    Api: 'updateWaiter',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 设置服务员服务状态
export const setWaiterServeStateApi = param => {
  const params = {
    Api: 'setWaiterServeState',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 根据id获得服务员信息
export const getWaiterByIdApi = param => {
  const params = {
    Api: 'getWaiterById',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 查询服务员列表信息(分页)
export const queryWaiterApi = param => {
  const params = {
    Api: 'queryWaiter',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 查询服务员列表信息
export const getWaiterListApi = param => {
  const params = {
    Api: 'getWaiterList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 添加号源模板信息
export const addSourceTemplateApi = param => {
  const params = {
    Api: 'addSourceTemplate',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除号源模板信息
export const deleteSourceTemplateApi = param => {
  const params = {
    Api: 'deleteSourceTemplate',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改号源模板信息
export const updateSourceTemplateApi = param => {
  const params = {
    Api: 'updateSourceTemplate',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置号源模板状态
export const setSourceTemplateStateApi = param => {
  const params = {
    Api: 'setSourceTemplateState',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询号源模板列表信息
export const querySourceTemplateApi = param => {
  const params = {
    Api: 'querySourceTemplate',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 保存号源配置信息
export const saveSourceConfigApi = param => {
  const params = {
    Api: 'saveSourceConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取号源配置列表信息
export const getSourceConfigListApi = param => {
  const params = {
    Api: 'getSourceConfigList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据商机id获取商机导入的扩展记录信息
export const getBusinessOpporImportExtendByIdApi = param => {
  const params = {
    Api: 'getBusinessOpporImportExtendById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置团长规则
export const setCommunityBuyingRuleApi = param => {
  const params = {
    Api: 'setCommunityBuyingRule',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加社区团长
export const addCommunityLeaderApi = param => {
  const params = {
    Api: 'addCommunityLeader',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 修改社区团长
export const updateCommunityLeaderApi = param => {
  const params = {
    Api: 'updateCommunityLeader',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置社区团长状态
export const setCommunityLeaderStateApi = param => {
  const params = {
    Api: 'setCommunityLeaderState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询社区团长列表
export const queryCommunityLeaderApi = param => {
  const params = {
    Api: 'queryCommunityLeader',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取团长规则信息
export const getCommunityBuyingRuleApi = param => {
  const params = {
    Api: 'getCommunityBuyingRule',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取社区团长信息
export const getCommunityLeaderByIdApi = param => {
  const params = {
    Api: 'getCommunityLeaderById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置默认等级
export const setBrandDefaulUserGradeByIdApi = param => {
  const params = {
    Api: 'setBrandDefaulUserGradeById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 分销提现申请记录
export const queryBrandUserRedAccountApi = param => {
  const params = {
    Api: 'queryBrandUserRedAccount',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 添加商圈信息
export const addBusinessDistrictApi = param => {
  const params = {
    Api: 'addBusinessDistrict',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置商圈状态信息
export const setBusinessDistrictCbdStateApi = param => {
  const params = {
    Api: 'setBusinessDistrictCbdState',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改商圈信息
export const updateBusinessDistrictApi = param => {
  const params = {
    Api: 'updateBusinessDistrict',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询商圈列表信息
export const queryBusinessDistrictApi = param => {
  const params = {
    Api: 'queryBusinessDistrict',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取商圈列表信息
export const getBusinessDistrictListApi = param => {
  const params = {
    Api: 'getBusinessDistrictList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取品牌公告
export const getBrandNoticeApi = param => {
  const params = {
    Api: 'getBrandNotice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 新增/更新品牌公告
export const saveOrUpdateBrandNoticeApi = param => {
  const params = {
    Api: 'saveOrUpdateBrandNotice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加供应商信息
export const addSupplierApi = param => {
  const params = {
    Api: 'addSupplier',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新供应商信息
export const updateSupplierApi = param => {
  const params = {
    Api: 'updateSupplier',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置供应商审核状态
export const setSupplierCheckStateApi = param => {
  const params = {
    Api: 'setSupplierCheckState',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id获取供应商信息
export const getSupplierByIdApi = param => {
  const params = {
    Api: 'getSupplierById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询供应商信息
export const querySupplierApi = param => {
  const params = {
    Api: 'querySupplier',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加供应商门店信息
export const addSupplierShopApi = param => {
  const params = {
    Api: 'addSupplierShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改供应商门店信息
export const updateSupplierShopApi = param => {
  const params = {
    Api: 'updateSupplierShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置供应商门店状态
export const setSupplierShopStateApi = param => {
  const params = {
    Api: 'setSupplierShopState',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id获取供应商门店信息
export const getSupplierShopByIdApi = param => {
  const params = {
    Api: 'getSupplierShopById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取供应商门店信息列表
export const getSupplierShopListApi = param => {
  const params = {
    Api: 'getSupplierShopList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询供应商门店信息
export const querySupplierShopApi = param => {
  const params = {
    Api: 'querySupplierShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询订单核销码
export const queryOrderWriteOffCodeApi = param => {
  const params = {
    Api: 'queryOrderWriteOffCode',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 同意提现申请记录
export const agreeWithdrawalApi = param => {
  const params = {
    Api: 'agreeWithdrawal',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更新商品是否在详情页展示
export const updateGoodsIsShowedInDetailApi = param => {
  const params = {
    Api: 'updateGoodsIsShowedInDetail',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询菜品评价
export const queryGoodsEvaluateApi = param => {
  const params = {
    Api: 'queryGoodsEvaluate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 置顶商品评价
export const toppingGoodsEvaluateApi = param => {
  const params = {
    Api: 'toppingGoodsEvaluate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 删除商品评价
export const deleteGoodsEvaluateApi = param => {
  const params = {
    Api: 'deleteGoodsEvaluate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 品牌行业排序
export const sortBrandCategoryApi = param => {
  const params = {
    Api: 'sortBrandCategory',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置社区团长接收微信消息类型
export const setCommunityLeaderReceiveWxMsgTypeApi = param => {
  const params = {
    Api: 'setCommunityLeaderReceiveWxMsgType',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询菜品统计对应的订单
export const queryGoodsByOrderApi = param => {
  const params = {
    Api: 'queryGoodsByOrder',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 营销活动排序
export const sortMarketingActivityApi = param => {
  const params = {
    Api: 'sortMarketingActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置商品搭售关联配置排序
export const setGoodsRelationConfigSortApi = param => {
  const params = {
    Api: 'setGoodsRelationConfigSort',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询分销团队
export const queryDitrubtionGroupApi = param => {
  const params = {
    Api: 'queryDitrubtionGroup',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 积分商城排序
export const updateMarketingActivitySortNumApi = param => {
  const params = {
    Api: 'updateMarketingActivitySortNum',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 保存分销活动
export const saveDistributionActivityApi = param => {
  const params = {
    Api: 'saveDistributionActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取品牌分销活动详情
export const getBrandDistributionActivityApi = param => {
  const params = {
    Api: 'getBrandDistributionActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更改活动状态——分销活动
export const updateDistributionStateApi = param => {
  const params = {
    Api: 'updateDistributionState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取我的下级人员信息
export const getDistributionSubsApi = param => {
  const params = {
    Api: 'getDistributionSubs',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询全品牌营业统计信息
export const queryBrandBusinessStatisticApi = param => {
  const params = {
    Api: 'queryBrandBusinessStatistic',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 全品牌店间结算
export const queryBrandShopSettlementApi = param => {
  const params = {
    Api: 'queryBrandShopSettlement',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 全品牌会员列表
export const queryCompanyUserApi = param => {
  const params = {
    Api: 'queryCompanyUser',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 全品牌会员卡数量
export const getCompanyUserCardListApi = param => {
  const params = {
    Api: 'getCompanyUserCardList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加仓库区域信息
export const addWarehouseAreaApi = param => {
  const params = {
    Api: 'addWarehouseArea',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除仓库区域信息
export const deleteWarehouseAreaApi = param => {
  const params = {
    Api: 'deleteWarehouseArea',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改仓库区域信息
export const updateWarehouseAreaApi = param => {
  const params = {
    Api: 'updateWarehouseArea',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询仓库区域列表信息
export const queryWarehouseAreaApi = param => {
  const params = {
    Api: 'queryWarehouseArea',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加仓库
export const addWarehouseApi = param => {
  const params = {
    Api: 'addWarehouse',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除仓库
export const deleteWarehouseApi = param => {
  const params = {
    Api: 'deleteWarehouse',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新仓库
export const updateWarehouseApi = param => {
  const params = {
    Api: 'updateWarehouse',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置仓库状态
export const setWarehouseStateApi = param => {
  const params = {
    Api: 'setWarehouseState',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id获取仓库
export const getWarehouseByIdApi = param => {
  const params = {
    Api: 'getWarehouseById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询仓库信息
export const queryWarehouseApi = param => {
  const params = {
    Api: 'queryWarehouse',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加商品库存管理信息
export const addStockManageApi = param => {
  const params = {
    Api: 'addStockManage',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 入库信息确认
export const inStockManageConfirmApi = param => {
  const params = {
    Api: 'inStockManageConfirm',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 出库信息确认
export const outStockManageConfirmApi = param => {
  const params = {
    Api: 'outStockManageConfirm',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 根据库存管理id获取库存管理信息关联商品列表
export const getStockManageAndRelGoodsListByIdApi = param => {
  const params = {
    Api: 'getStockManageAndRelGoodsListById',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询商品库存管理信息
export const queryStockManageApi = param => {
  const params = {
    Api: 'queryStockManage',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询商品库存管理信息明细
export const queryStockManageDetailedApi = param => {
  const params = {
    Api: 'queryStockManageDetailed',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询出入库汇总
export const queryOutAndInStockSummaryApi = param => {
  const params = {
    Api: 'queryOutAndInStockSummary',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询商品sku详情(用于库存管理)
export const queryGoodsSkuDetailForStockManageApi = param => {
  const params = {
    Api: 'queryGoodsSkuDetailForStockManage',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 设置预警库存
export const setWarnInventoryApi = param => {
  const params = {
    Api: 'setWarnInventory',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 获取品牌分销商
export const getBrandDistributionPersonsApi = param => {
  const params = {
    Api: 'getBrandDistributionPersons',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 分销商审核
export const auditDistributionPersonApi = param => {
  const params = {
    Api: 'auditDistributionPerson',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加跑腿业务流程
export const addErrandProcessApi = param => {
  const params = {
    Api: 'addErrandProcess',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询跑腿业务流程
export const queryErrandProcessApi = param => {
  const params = {
    Api: 'queryErrandProcess',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改跑腿业务流程
export const updateErrandProcessApi = param => {
  const params = {
    Api: 'updateErrandProcess',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除跑腿业务流程
export const deleteErrandProcessApi = param => {
  const params = {
    Api: 'deleteErrandProcess',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取商品详情列表信息
export const getGoodsDetailListApi = param => {
  const params = {
    Api: 'getGoodsDetailList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 获取运维行业信息
export const queryIndustryApi = param => {
  const params = {
    Api: 'queryIndustry',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 发布商品模板
export const addGoodsTemplateApi = param => {
  const params = {
    Api: 'addGoodsTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 商品模板引用
export const goodsTemplateQuoteApi = param => {
  const params = {
    Api: 'goodsTemplateQuote',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 商品模板图片引用
export const goodsTemplatePicQuoteApi = param => {
  const params = {
    Api: 'goodsTemplatePicQuote',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询对应品牌发布的商品数量
export const getBrandGoodsTemplateCountApi = param => {
  const params = {
    Api: 'getBrandGoodsTemplateCount',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询商品模板列表信息
export const queryGoodsTemplateApi = param => {
  const params = {
    Api: 'queryGoodsTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 根据id查询商品模板
export const getGoodsTemplateByIdApi = param => {
  const params = {
    Api: 'getGoodsTemplateById',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 删除商品模板
export const deleteGoodsTemplateApi = param => {
  const params = {
    Api: 'deleteGoodsTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询商品列表(用于选择商品)
export const queryGoodsListApi = param => {
  const params = {
    Api: 'queryGoodsList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 添加公司用户等级
export const addCompanyUserGradeApi = param => {
  const params = {
    Api: 'addCompanyUserGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 更新公司用户等级
export const updateCompanyUserGradeApi = param => {
  const params = {
    Api: 'updateCompanyUserGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 删除公司会员等级
export const deleteCompanyUserGradeApi = param => {
  const params = {
    Api: 'deleteCompanyUserGrade',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 分销注册(注册成为分销商、活动会员、订单会员)
export const registerDistributionRelationshipApi = param => {
  const params = {
    Api: 'registerDistributionRelationship',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加品牌订单扩展配置
export const addBrandOrderExtendConfigApi = param => {
  const params = {
    Api: 'addBrandOrderExtendConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除品牌订单扩展配置
export const deleteBrandOrderExtendConfigApi = param => {
  const params = {
    Api: 'deleteBrandOrderExtendConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新品牌订单扩展配置
export const updateBrandOrderExtendConfigApi = param => {
  const params = {
    Api: 'updateBrandOrderExtendConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询品牌订单扩展配置列表
export const queryBrandOrderExtendConfigApi = param => {
  const params = {
    Api: 'queryBrandOrderExtendConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 员工评价列表
export const queryWaiterEvaluatesApi = param => {
  const params = {
    Api: 'queryWaiterEvaluates',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 新增可评价员工
export const addEvalWaitersApi = param => {
  const params = {
    Api: 'addEvalWaiters',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 删除评价
export const deleteWaiterEvaluateApi = param => {
  const params = {
    Api: 'deleteWaiterEvaluate',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 新增/更新新闻类别
export const saveOrUpdateNewsTypeApi = param => {
  const params = {
    Api: 'saveOrUpdateNewsType',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 分页查询新闻类别
export const queryNewsTypeApi = param => {
  const params = {
    Api: 'queryNewsType',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 删除新闻类别
export const deleteNewsTypeApi = param => {
  const params = {
    Api: 'deleteNewsType',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id查新闻类别详情
export const getNewsTypeByIdApi = param => {
  const params = {
    Api: 'getNewsTypeById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 新增/更新新闻
export const saveOrUpdateNewsApi = param => {
  const params = {
    Api: 'saveOrUpdateNews',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 分页查询新闻
export const queryNewsApi = param => {
  const params = {
    Api: 'queryNews',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id删除新闻
export const deleteNewsByIdApi = param => {
  const params = {
    Api: 'deleteNewsById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 上架/下架/作废新闻
export const updateNewsStatusApi = param => {
  const params = {
    Api: 'updateNewsStatus',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id获取新闻详情
export const getNewsByIdApi = param => {
  const params = {
    Api: 'getNewsById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 批量设置公司相关配置
export const batchSetCompanyRelConfigApi = param => {
  const params = {
    Api: 'batchSetCompanyRelConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加企业微信配置
export const addCorpConfigApi = param => {
  const params = {
    Api: 'addCorpConfig',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 查询企业微信配置
export const queryCorpConfigApi = param => {
  const params = {
    Api: 'queryCorpConfig',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 修改企业微信配置
export const updateCorpConfigApi = param => {
  const params = {
    Api: 'updateCorpConfig',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 同步企业微信客服
export const synchCorpUserApi = param => {
  const params = {
    Api: 'synchCorpUser',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 获取企业微信客服列表
export const getCorpUserListApi = param => {
  const params = {
    Api: 'getCorpUserList',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 添加企业微信客服角色
export const addCorpUserRoleApi = param => {
  const params = {
    Api: 'addCorpUserRole',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 获取企业微信客服角色
export const getCorpUserRoleListApi = param => {
  const params = {
    Api: 'getCorpUserRoleList',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 修改企业微信客服角色
export const updateCorpUserRoleApi = param => {
  const params = {
    Api: 'updateCorpUserRole',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 删除企业微信客服角色
export const deleteCorpUserRoleApi = param => {
  const params = {
    Api: 'deleteCorpUserRole',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 设置企业微信客服角色
export const setCorpUserRoleApi = param => {
  const params = {
    Api: 'setCorpUserRole',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 激活企业微信客服
export const activateCorpUserApi = param => {
  const params = {
    Api: 'activateCorpUser',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 获取聊天记录列表
export const getChatRecordListApi = param => {
  const params = {
    Api: 'getChatRecordList',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 获取聊天记录详情列表
export const getChatRecordDetailListApi = param => {
  const params = {
    Api: 'getChatRecordDetailList',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 保存公司自定义配置
export const saveCompanyCustomConfigApi = param => {
  const params = {
    Api: 'saveCompanyCustomConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取公司自定义配置
export const getCompanyCustomConfigApi = param => {
  const params = {
    Api: 'getCompanyCustomConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询客户端访问日统计
export const queryClientVisitDayStatisticsApi = param => {
  const params = {
    Api: 'queryClientVisitDayStatistics',
    Params: param
  }
  return axios.request({
    url: 'flow_callApi.do',
    data: params
  })
}
// 查询商品访问统计
export const queryGoodsVisitStatisticsApi = param => {
  const params = {
    Api: 'queryGoodsVisitStatistics',
    Params: param
  }
  return axios.request({
    url: 'flow_callApi.do',
    data: params
  })
}
// 查询商品访问日统计
export const queryGoodsVisitDayStatisticsApi = param => {
  const params = {
    Api: 'queryGoodsVisitDayStatistics',
    Params: param
  }
  return axios.request({
    url: 'flow_callApi.do',
    data: params
  })
}
// 获取可用入库详情列表
export const getUsableInStockDetailListApi = param => {
  const params = {
    Api: 'getUsableInStockDetailList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 出库捡货确认(扣减库存)
export const outStockPickingConfirmApi = param => {
  const params = {
    Api: 'outStockPickingConfirm',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 出库回退捡货
export const outStockReturnPickingApi = param => {
  const params = {
    Api: 'outStockReturnPicking',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 出库完成
export const outStockFinishApi = param => {
  const params = {
    Api: 'outStockFinish',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 上门服务区域
export const queryLongitudeLatitudeApi = param => {
  const params = {
    Api: 'queryLongitudeLatitude',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 上门服务区域——新增/更新经纬度
export const saveOrUpdateLongitudeLatitudeApi = param => {
  const params = {
    Api: 'saveOrUpdateLongitudeLatitude',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询被代理公司
export const queryAgentCompanyApi = param => {
  const params = {
    Api: 'queryAgentCompany',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除经纬度
export const deleteLongitudeLatitudeApi = param => {
  const params = {
    Api: 'deleteLongitudeLatitude',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询预约统计
export const queryReserveStatisticsApi = param => {
  const params = {
    Api: 'queryReserveStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询预约统计详情
export const queryReserveStatisticsDetailApi = param => {
  const params = {
    Api: 'queryReserveStatisticsDetail',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 添加商品模板用于供应商品
export const addGoodsTemplateForSupplyApi = param => {
  const params = {
    Api: 'addGoodsTemplateForSupply',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询商品模板用于供应商品
export const queryGoodsTemplateForSupplyApi = param => {
  const params = {
    Api: 'queryGoodsTemplateForSupply',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 设置商品模板是否上架
export const setGoodsTemplateIsShelvesApi = param => {
  const params = {
    Api: 'setGoodsTemplateIsShelves',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 一键代售添加商品
export const onekeyAgentSaleAddGoodsApi = param => {
  const params = {
    Api: 'onekeyAgentSaleAddGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 根据id获取商品模板用于供应商商品
export const getGoodsTemplateForSupplyByIdApi = param => {
  const params = {
    Api: 'getGoodsTemplateForSupplyById',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 更新商品模板用于供应商商品
export const updateGoodsTemplateForSupplyApi = param => {
  const params = {
    Api: 'updateGoodsTemplateForSupply',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 修改门店自动化配置
export const updateShopAutoApi = param => {
  const params = {
    Api: 'updateShopAuto',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 保存检查任务和条目
export const saveInspectTaskAndItemApi = param => {
  const params = {
    Api: 'saveInspectTaskAndItem',
    Params: param
  }
  return axios.request({
    url: 'basic1_callApi.do',
    data: params
  })
}
// 设置检查任务配置
export const setInspectTaskConfigApi = param => {
  const params = {
    Api: 'setInspectTaskConfig',
    Params: param
  }
  return axios.request({
    url: 'basic1_callApi.do',
    data: params
  })
}
// 添加检查任务和配置
export const addInspectTaskAndConfigApi = param => {
  const params = {
    Api: 'addInspectTaskAndConfig',
    Params: param
  }
  return axios.request({
    url: 'basic1_callApi.do',
    data: params
  })
}
// 更新检查任务和配置
export const updateInspectTaskAndConfigApi = param => {
  const params = {
    Api: 'updateInspectTaskAndConfig',
    Params: param
  }
  return axios.request({
    url: 'basic1_callApi.do',
    data: params
  })
}
// 设置检查任务是否有效
export const setInspectTaskIsValidApi = param => {
  const params = {
    Api: 'setInspectTaskIsValid',
    Params: param
  }
  return axios.request({
    url: 'basic1_callApi.do',
    data: params
  })
}
// 根据id获取检查任务条目列表
export const getInspectTaskAndItemListByIdApi = param => {
  const params = {
    Api: 'getInspectTaskAndItemListById',
    Params: param
  }
  return axios.request({
    url: 'basic1_callApi.do',
    data: params
  })
}
// 查询检查任务
export const queryInspectTaskApi = param => {
  const params = {
    Api: 'queryInspectTask',
    Params: param
  }
  return axios.request({
    url: 'basic1_callApi.do',
    data: params
  })
}
// 新增/修改出账账户
export const saveOrUpdateAccountOutApi = param => {
  const params = {
    Api: 'saveOrUpdateAccountOut',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 分页查询出账账户
export const queryAccountOutApi = param => {
  const params = {
    Api: 'queryAccountOut',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 新增/修改入账账户
export const saveOrUpdateAccountInApi = param => {
  const params = {
    Api: 'saveOrUpdateAccountIn',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 分页查询入账账户
export const queryAccountInApi = param => {
  const params = {
    Api: 'queryAccountIn',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询账户流水
export const queryAccountWaterApi = param => {
  const params = {
    Api: 'queryAccountWater',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加报名活动
export const addEnrollActivityApi = param => {
  const params = {
    Api: 'addEnrollActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更新报名活动
export const updateEnrollActivityApi = param => {
  const params = {
    Api: 'updateEnrollActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置报名活动是否有效
export const setEnrollActivityIsValidApi = param => {
  const params = {
    Api: 'setEnrollActivityIsValid',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id获取报名活动
export const getEnrollActivityByIdApi = param => {
  const params = {
    Api: 'getEnrollActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询报名活动
export const queryEnrollActivityApi = param => {
  const params = {
    Api: 'queryEnrollActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加报名活动报名记录
export const addEnrollActivityRecordApi = param => {
  const params = {
    Api: 'addEnrollActivityRecord',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询报名活动报名记录
export const queryEnrollActivityRecordApi = param => {
  const params = {
    Api: 'queryEnrollActivityRecord',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询报名活动用户记录
export const queryEnrollActivityUserRecordApi = param => {
  const params = {
    Api: 'queryEnrollActivityUserRecord',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询门店储值使用结算金额详情
export const queryRealRechargeUseMoneyDetailApi = param => {
  const params = {
    Api: 'queryRealRechargeUseMoneyDetail',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询店间结算详情列表
export const queryShopSettlementDetailListApi = param => {
  const params = {
    Api: 'queryShopSettlementDetailList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询门店应收金额详情
export const queryRealRechargeUseElseShopMoneyDetailApi = param => {
  const params = {
    Api: 'queryRealRechargeUseElseShopMoneyDetail',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询门店应付金额详情
export const queryRealElseShopUseMoneyDetailApi = param => {
  const params = {
    Api: 'queryRealElseShopUseMoneyDetail',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 修改企业微信客服
export const updateCorpUserApi = param => {
  const params = {
    Api: 'updateCorpUser',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 查询用户嘉宾
export const queryUserGuestApi = param => {
  const params = {
    Api: 'queryUserGuest',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据userID获取用户信息
export const getUserInfoByIdApi = param => {
  const params = {
    Api: 'getUserInfoById',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据用户id更新用户信息
export const updateUserByIdApi = param => {
  const params = {
    Api: 'updateUserById',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据用户id设置用户信息
export const setUserByIdApi = param => {
  const params = {
    Api: 'setUserById',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询订单评价列表
export const queryOrderEvaluationListApi = param => {
  const params = {
    Api: 'queryOrderEvaluationList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 删除订单评价
export const deleteOrderEvaluationApi = param => {
  const params = {
    Api: 'deleteOrderEvaluation',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 查询门店评价列表
export const queryShopEvaluationListApi = param => {
  const params = {
    Api: 'queryShopEvaluationList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 删除门店评价
export const deleteShopEvaluationApi = param => {
  const params = {
    Api: 'deleteShopEvaluation',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 添加素材类型
export const addMaterialTypeApi = param => {
  const params = {
    Api: 'addMaterialType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 更新素材类型
export const updateMaterialTypeApi = param => {
  const params = {
    Api: 'updateMaterialType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 删除素材类型
export const deleteMaterialTypeApi = param => {
  const params = {
    Api: 'deleteMaterialType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 根据id获取素材类型
export const getMaterialTypeByIdApi = param => {
  const params = {
    Api: 'getMaterialTypeById',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询素材类型
export const queryMaterialTypeApi = param => {
  const params = {
    Api: 'queryMaterialType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 添加素材
export const addMaterialApi = param => {
  const params = {
    Api: 'addMaterial',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 删除素材
export const deleteMaterialApi = param => {
  const params = {
    Api: 'deleteMaterial',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 更新素材
export const updateMaterialApi = param => {
  const params = {
    Api: 'updateMaterial',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 根据id获取素材
export const getMaterialByIdApi = param => {
  const params = {
    Api: 'getMaterialById',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 设置素材是否有效
export const setMaterialMsgIsValidApi = param => {
  const params = {
    Api: 'setMaterialMsgIsValid',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询素材
export const queryMaterialApi = param => {
  const params = {
    Api: 'queryMaterial',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 设置品牌用户服务员工id接口
export const setBrandUserServeStaffIdApi = param => {
  const params = {
    Api: 'setBrandUserServeStaffId',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据条件统计品牌用户数
export const getBrandUserCountByCondApi = param => {
  const params = {
    Api: 'getBrandUserCountByCond',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 添加员工工作交接
export const addStaffWorkBandoverApi = param => {
  const params = {
    Api: 'addStaffWorkBandover',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查看品牌用户交接记录
export const queryBrandUserHandoverApi = param => {
  const params = {
    Api: 'queryBrandUserHandover',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询员工工作交接
export const queryStaffWorkBandoverApi = param => {
  const params = {
    Api: 'queryStaffWorkBandover',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 获取供应商提现账户信息
export const getWithdrawInfoApi = param => {
  const params = {
    Api: 'getWithdrawInfo',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除提现账户
export const deleteWithdrawInfoApi = param => {
  const params = {
    Api: 'deleteWithdrawInfo',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询弹出商品对应电子券列表
export const queryTicketTCSPListApi = param => {
  const params = {
    Api: 'queryTicketTCSPList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 弹出商品领券
export const receiveTicketTCSPApi = param => {
  const params = {
    Api: 'receiveTicketTCSP',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置素材是否置顶
export const setMaterialIsTopApi = param => {
  const params = {
    Api: 'setMaterialIsTop',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询中奖记录列表
export const getWinningRecordListApi = param => {
  const params = {
    Api: 'getWinningRecordList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置中奖记录状态
export const setShareActivityPrizeStateApi = param => {
  const params = {
    Api: 'setShareActivityPrizeState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置资质认证
export const setAptitudeAuthentApi = param => {
  const params = {
    Api: 'setAptitudeAuthent',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询供应商电子券使用
export const querySupplierTicketUseApi = param => {
  const params = {
    Api: 'querySupplierTicketUse',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询活动对应的砍价记录
export const queryActivityCutListApi = param => {
  const params = {
    Api: 'queryActivityCutList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 新增/更新赞助商(冠名商)
export const saveOrUpdateSponsorApi = param => {
  const params = {
    Api: 'saveOrUpdateSponsor',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 分页查询赞助商
export const querySponsorApi = param => {
  const params = {
    Api: 'querySponsor',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据赞助商id获取详情
export const getSponsorByIdApi = param => {
  const params = {
    Api: 'getSponsorById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据赞助商id删除
export const deleteSponsorByIdApi = param => {
  const params = {
    Api: 'deleteSponsorById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 新增/更新藏宝活动
export const saveOrUpdateTreasureActivityApi = param => {
  const params = {
    Api: 'saveOrUpdateTreasureActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 分页查询藏宝活动
export const queryTreasureActivityApi = param => {
  const params = {
    Api: 'queryTreasureActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id获取藏宝活动详情
export const getTreasureActivityByIdApi = param => {
  const params = {
    Api: 'getTreasureActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 开启/停止/作废藏宝活动
export const updateTreasureActivityStateApi = param => {
  const params = {
    Api: 'updateTreasureActivityState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 生成藏宝活动暗号
export const generateTreasureSecretPwdApi = param => {
  const params = {
    Api: 'generateTreasureSecretPwd',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 新增/更新红包
export const saveOrUpdateTreasureActivityRedApi = param => {
  const params = {
    Api: 'saveOrUpdateTreasureActivityRed',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 分页查询红包
export const queryTreasureActivityRedApi = param => {
  const params = {
    Api: 'queryTreasureActivityRed',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id获取红包详情
export const getTreasureActivityRedByIdApi = param => {
  const params = {
    Api: 'getTreasureActivityRedById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取核心指数统计
export const getCoreIndexStatisticsApi = param => {
  const params = {
    Api: 'getCoreIndexStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 获取当日新增统计
export const getCurDayNewAddCountApi = param => {
  const params = {
    Api: 'getCurDayNewAddCount',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 爆客侠-统计
export const queryBKXHomePageApi = param => {
  const params = {
    Api: 'queryBKXHomePage',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 设置素材类型排序
export const setMaterialTypeSortNumApi = param => {
  const params = {
    Api: 'setMaterialTypeSortNum',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 添加抽奖活动
export const addPrizeActivityApi = param => {
  const params = {
    Api: 'addPrizeActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更新抽奖活动
export const updatePrizeActivityApi = param => {
  const params = {
    Api: 'updatePrizeActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id获取抽奖活动
export const getPrizeActivityByIdApi = param => {
  const params = {
    Api: 'getPrizeActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询抽奖活动(用于管理平台)
export const queryPrizeActivityForManageApi = param => {
  const params = {
    Api: 'queryPrizeActivityForManage',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取奖品列表和中奖数
export const getPrizeGoodsListAndWinPrizeNumApi = param => {
  const params = {
    Api: 'getPrizeGoodsListAndWinPrizeNum',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询中奖参与和奖品
export const queryWinPrizePartakeAndPrizeGoodsApi = param => {
  const params = {
    Api: 'queryWinPrizePartakeAndPrizeGoods',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 设置抽奖活动状态
export const setPrizeActivityStateApi = param => {
  const params = {
    Api: 'setPrizeActivityState',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取电子券Bean列表
export const getTicketBeanListApi = param => {
  const params = {
    Api: 'getTicketBeanList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 手动开奖
export const manualOpenPrizeApi = param => {
  const params = {
    Api: 'manualOpenPrize',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更新海报商品接口
export const updatePosterGoodsApi = param => {
  const params = {
    Api: 'updatePosterGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 获得海报商品接口
export const getPosterGoodsApi = param => {
  const params = {
    Api: 'getPosterGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 财务报表 - 会员统计 - 赠送积分按日、月
export const queryZSJFStatisticsWithDayApi = param => {
  const params = {
    Api: 'queryZSJFStatisticsWithDay',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 财务报表 - 会员统计 - 赠送积分汇总
export const queryZSJFStatisticsApi = param => {
  const params = {
    Api: 'queryZSJFStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 财务报表 - 会员统计 - 赠送积分详情列表
export const queryZSJFDetailListApi = param => {
  const params = {
    Api: 'queryZSJFDetailList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询交接记录
export const queryHandoverRecordApi = param => {
  const params = {
    Api: 'queryHandoverRecord',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 添加公告
export const addBrandNoticeApi = param => {
  const params = {
    Api: 'addBrandNotice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除公告
export const deleteBrandNoticeApi = param => {
  const params = {
    Api: 'deleteBrandNotice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新公告
export const updateBrandNoticeApi = param => {
  const params = {
    Api: 'updateBrandNotice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id获取公告
export const getBrandNoticeByIdApi = param => {
  const params = {
    Api: 'getBrandNoticeById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 外卖红包——新增/更新配置
export const saveOrUpdateTakeoutConfigApi = param => {
  const params = {
    Api: 'saveOrUpdateTakeoutConfig',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 外卖红包——获得配置信息
export const getTakeoutConfigApi = param => {
  const params = {
    Api: 'getTakeoutConfig',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取公告列表
export const getBrandNoticeListApi = param => {
  const params = {
    Api: 'getBrandNoticeList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 饿了么pid查询
export const queryElmPidApi = param => {
  const params = {
    Api: 'queryElmPid',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 新增/更新饿了么pid
export const saveOrUpdateElmPidApi = param => {
  const params = {
    Api: 'saveOrUpdateElmPid',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 更新饿了么pid状态
export const updateElmPidStatusApi = param => {
  const params = {
    Api: 'updateElmPidStatus',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询储备金流水
export const queryReserveFundWaterApi = param => {
  const params = {
    Api: 'queryReserveFundWater',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 系统账户提现申请
export const applyForWithdrawalForAccountApi = param => {
  const params = {
    Api: 'applyForWithdrawalForAccount',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加门店商品类型信息
export const addShopGoodsTypeApi = param => {
  const params = {
    Api: 'addShopGoodsType',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 获取门店商品类型列表
export const getShopGoodsTypeListApi = param => {
  const params = {
    Api: 'getShopGoodsTypeList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 添加门店商品信息
export const addShopGoodsApi = param => {
  const params = {
    Api: 'addShopGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 更新门店商品信息
export const updateShopGoodsApi = param => {
  const params = {
    Api: 'updateShopGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 添加门店商品sku信息
export const addShopGoodsSkuApi = param => {
  const params = {
    Api: 'addShopGoodsSku',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 更新门店商品sku
export const updateShopGoodsSkuApi = param => {
  const params = {
    Api: 'updateShopGoodsSku',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 添加门店商品搭售关联配置
export const addShopGoodsRelationConfigApi = param => {
  const params = {
    Api: 'addShopGoodsRelationConfig',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 修改门店商品搭售关联配置
export const updateShopGoodsRelationConfigApi = param => {
  const params = {
    Api: 'updateShopGoodsRelationConfig',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 批量设置门店商品sku信息
export const batchSetShopGoodsSkuApi = param => {
  const params = {
    Api: 'batchSetShopGoodsSku',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 根据品牌获得高级分销信息
export const getDisConfigByBrandIdApi = param => {
  const params = {
    Api: 'getDisConfigByBrandId',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 保存/更新高级分销配置
export const saveOrUpdateDisConfigApi = param => {
  const params = {
    Api: 'saveOrUpdateDisConfig',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询高级分销注册订单
export const queryTopRegisterOrderApi = param => {
  const params = {
    Api: 'queryTopRegisterOrder',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 添加信息类型
export const addInfoTypeApi = param => {
  const params = {
    Api: 'addInfoType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 删除信息类型
export const deleteInfoTypeApi = param => {
  const params = {
    Api: 'deleteInfoType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 更新信息类型
export const updateInfoTypeApi = param => {
  const params = {
    Api: 'updateInfoType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 根据id获取信息类型
export const getInfoTypeByIdApi = param => {
  const params = {
    Api: 'getInfoTypeById',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询信息类型
export const queryInfoTypeApi = param => {
  const params = {
    Api: 'queryInfoType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 批量设置信息类型排序号
export const batchSetInfoTypeSortNumApi = param => {
  const params = {
    Api: 'batchSetInfoTypeSortNum',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 根据id获取信息发布
export const getInfoReleaseByIdApi = param => {
  const params = {
    Api: 'getInfoReleaseById',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询信息发布
export const queryInfoReleaseApi = param => {
  const params = {
    Api: 'queryInfoRelease',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 设置信息发布信息
export const setInfoReleaseMsgApi = param => {
  const params = {
    Api: 'setInfoReleaseMsg',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询信息发布评论
export const queryReleaseEvaluateApi = param => {
  const params = {
    Api: 'queryReleaseEvaluate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 外卖订单查询
export const queryTakeoutOrderApi = param => {
  const params = {
    Api: 'queryTakeoutOrder',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 电影订单查询
export const queyrMovieOrderApi = param => {
  const params = {
    Api: 'queyrMovieOrder',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 获取储备金流水统计
export const getReserveFundWaterCountApi = param => {
  const params = {
    Api: 'getReserveFundWaterCount',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加共享门店
export const addShareShopApi = param => {
  const params = {
    Api: 'addShareShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加品牌关联共享门店
export const addBrandRelShareShopApi = param => {
  const params = {
    Api: 'addBrandRelShareShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置品牌门店关联信息
export const setBrandShopRelMsgApi = param => {
  const params = {
    Api: 'setBrandShopRelMsg',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取共享门店列表
export const getShareShopListApi = param => {
  const params = {
    Api: 'getShareShopList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置供应商是否开启功能配置
export const setSupplierIsOpenFunConfigApi = param => {
  const params = {
    Api: 'setSupplierIsOpenFunConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询共享门店
export const queryShareShopApi = param => {
  const params = {
    Api: 'queryShareShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据品牌查询品牌门店关联
export const queryBrandShopRelByBrandApi = param => {
  const params = {
    Api: 'queryBrandShopRelByBrand',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据门店查询品牌门店关联
export const queryBrandShopRelByShopApi = param => {
  const params = {
    Api: 'queryBrandShopRelByShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加储备金
export const addReserveFundApi = param => {
  const params = {
    Api: 'addReserveFund',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询品牌用户分组
export const queryBrandUserGroupApi = param => {
  const params = {
    Api: 'queryBrandUserGroup',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 增加品牌用户分组
export const addBrandUserGroupApi = param => {
  const params = {
    Api: 'addBrandUserGroup',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 删除品牌用户分组
export const deleteBrandUserGroupApi = param => {
  const params = {
    Api: 'deleteBrandUserGroup',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 获取高级分销商品接口
export const queryDisGoodsApi = param => {
  const params = {
    Api: 'queryDisGoods',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 新增/修改配送设置规则
export const saveOrUpdateFreightRuleApi = param => {
  const params = {
    Api: 'saveOrUpdateFreightRule',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询配送设置规则
export const getFreightRuleListApi = param => {
  const params = {
    Api: 'getFreightRuleList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除配送设置规则
export const deleteFreightRuleApi = param => {
  const params = {
    Api: 'deleteFreightRule',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id查询配送设置规则
export const getFreightRuleByIdApi = param => {
  const params = {
    Api: 'getFreightRuleById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置配送设置规则启用
export const setFreightRuleEnableApi = param => {
  const params = {
    Api: 'setFreightRuleEnable',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询表白墙
export const queryConfessionWallApi = param => {
  const params = {
    Api: 'queryConfessionWall',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 根据id获取表白墙
export const getConfessionWallByIdApi = param => {
  const params = {
    Api: 'getConfessionWallById',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 删除表白墙
export const deleteConfessionWallApi = param => {
  const params = {
    Api: 'deleteConfessionWall',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 设置表白墙信息
export const setConfessionWallMsgApi = param => {
  const params = {
    Api: 'setConfessionWallMsg',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询表白墙评论
export const queryConfessionWallEvaluateApi = param => {
  const params = {
    Api: 'queryConfessionWallEvaluate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询导出记录合计
export const queryExportRecordTotalApi = param => {
  const params = {
    Api: 'queryExportRecordTotal',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询制卡信息合计
export const queryCardMakeRecordTotalApi = param => {
  const params = {
    Api: 'queryCardMakeRecordTotal',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 批量导入外部商品码
export const batchImportOutGoodsCodeApi = param => {
  const params = {
    Api: 'batchImportOutGoodsCode',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询商品码
export const queryGoodsCodeApi = param => {
  const params = {
    Api: 'queryGoodsCode',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 保存核销码导出记录
export const saveWriteOffCodeRecordApi = param => {
  const params = {
    Api: 'saveWriteOffCodeRecord',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 核销码导出列表
export const queryWriteOffCodeExportRecordApi = param => {
  const params = {
    Api: 'queryWriteOffCodeExportRecord',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 分页查询导出的核销码
export const queryWOCApi = param => {
  const params = {
    Api: 'queryWOC',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 作废核销码
export const cancelWOCApi = param => {
  const params = {
    Api: 'cancelWOC',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询用户企业信息
export const queryUserEnterpriseApi = param => {
  const params = {
    Api: 'queryUserEnterprise',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据条件获取用户企业信息
export const getUserEnterpriseByCondApi = param => {
  const params = {
    Api: 'getUserEnterpriseByCond',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置用户企业信息
export const setUserEnterpriseMsgApi = param => {
  const params = {
    Api: 'setUserEnterpriseMsg',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询用户求职信息
export const queryUserJobWantedMsgApi = param => {
  const params = {
    Api: 'queryUserJobWantedMsg',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据条件获取用户求职信息
export const getUserJobWantedMsgByCondApi = param => {
  const params = {
    Api: 'getUserJobWantedMsgByCond',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置用户求职信息
export const setUserJobWantedMsgMsgApi = param => {
  const params = {
    Api: 'setUserJobWantedMsgMsg',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置招聘岗位信息
export const setRecruitPostMsgApi = param => {
  const params = {
    Api: 'setRecruitPostMsg',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 根据id获取招聘岗位
export const getRecruitPostByIdApi = param => {
  const params = {
    Api: 'getRecruitPostById',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询招聘岗位
export const queryRecruitPostApi = param => {
  const params = {
    Api: 'queryRecruitPost',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询招聘岗位应聘信息
export const queryRecruitPostApplicationApi = param => {
  const params = {
    Api: 'queryRecruitPostApplication',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 获取跑腿配置
export const getErrandConfigApi = param => {
  const params = {
    Api: 'getErrandConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置跑腿配置
export const setErrandConfigApi = param => {
  const params = {
    Api: 'setErrandConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除商品码
export const deleteGoodsCodeApi = param => {
  const params = {
    Api: 'deleteGoodsCode',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询跑腿人员对应订单合计列表
export const queryOrderErrandTotalListApi = param => {
  const params = {
    Api: 'queryOrderErrandTotalList',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询跑腿人员对应订单合计列表
export const queryOrderErrandTotalList2Api = param => {
  const params = {
    Api: 'queryOrderErrandTotalList2',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询跑腿人员收益明细
export const queryOrderErrandIncomeDetailApi = param => {
  const params = {
    Api: 'queryOrderErrandIncomeDetail',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询跑腿人员收益明细
export const queryOrderErrandIncomeDetail2Api = param => {
  const params = {
    Api: 'queryOrderErrandIncomeDetail2',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 把打印机添加到易联云应用中
export const ylyAddPrinterApi = param => {
  const params = {
    Api: 'ylyAddPrinter',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 打印机在易联云平台的状态
export const ylyGetPrintStatusApi = param => {
  const params = {
    Api: 'ylyGetPrintStatus',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 把打印机添加到商鹏应用中
export const spAddPrinterApi = param => {
  const params = {
    Api: 'spAddPrinter',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 打印机在商鹏平台的状态
export const spGetPrintStatusApi = param => {
  const params = {
    Api: 'spGetPrintStatus',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加微信自动回复配置
export const addWechatAutoReplyConfigApi = param => {
  const params = {
    Api: 'addWechatAutoReplyConfig',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 更新微信自动回复配置
export const updateWechatAutoReplyConfigApi = param => {
  const params = {
    Api: 'updateWechatAutoReplyConfig',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 根据条件查询微信自动回复配置
export const getWechatAutoReplyConfigByConditApi = param => {
  const params = {
    Api: 'getWechatAutoReplyConfigByCondit',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 申请退款
export const applyForRefundApi = param => {
  const params = {
    Api: 'applyForRefund',
    Params: param
  }
  return axios.request({
    url: 'pay_callApi.do',
    data: params
  })
}
// 获取门店关联的品牌列表
export const getShopRelBrandListApi = param => {
  const params = {
    Api: 'getShopRelBrandList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 操作分销商
export const operateDistributorApi = param => {
  const params = {
    Api: 'operateDistributor',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 配送信息
export const getOrderAndDetailByOrderIdApi = param => {
  const params = {
    Api: 'getOrderAndDetailByOrderId',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 设置提现配置
export const setWithdrawConfigApi = param => {
  const params = {
    Api: 'setWithdrawConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加集团
export const addGroupApi = param => {
  const params = {
    Api: 'addGroup',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除集团
export const deleteGroupApi = param => {
  const params = {
    Api: 'deleteGroup',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新集团
export const updateGroupApi = param => {
  const params = {
    Api: 'updateGroup',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询集团
export const queryGroupApi = param => {
  const params = {
    Api: 'queryGroup',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询集团关联的门店
export const queryGroupRelShopApi = param => {
  const params = {
    Api: 'queryGroupRelShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 集团添加门店申请
export const groupAddShopRelApplyApi = param => {
  const params = {
    Api: 'groupAddShopRelApply',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置集团微信支付账号信息
export const setGroupWxPayAccountMsgApi = param => {
  const params = {
    Api: 'setGroupWxPayAccountMsg',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据集团id获取集团微信支付账号信息
export const getGroupWxPayAccountMsgByGroupIdApi = param => {
  const params = {
    Api: 'getGroupWxPayAccountMsgByGroupId',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询品牌集团关联
export const queryBrandGroupRelApi = param => {
  const params = {
    Api: 'queryBrandGroupRel',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询集团余额流水
export const queryGroupBalanceWaterApi = param => {
  const params = {
    Api: 'queryGroupBalanceWater',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id获取门店信息
export const getShopByIdApi = param => {
  const params = {
    Api: 'getShopById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 集团储备金划拨到门店
export const groupReserveFundTransferToShopApi = param => {
  const params = {
    Api: 'groupReserveFundTransferToShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取储备金抽成统计
export const getReserveFundCommissionCountApi = param => {
  const params = {
    Api: 'getReserveFundCommissionCount',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除客服信息
export const deleteCustServiceApi = param => {
  const params = {
    Api: 'deleteCustService',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 添加客服信息
export const addCustServiceApi = param => {
  const params = {
    Api: 'addCustService',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询客服信息
export const queryCustServiceApi = param => {
  const params = {
    Api: 'queryCustService',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 添加自动回复规则
export const addAutoReplyRuleApi = param => {
  const params = {
    Api: 'addAutoReplyRule',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 删除自动回复规则
export const deleteAutoReplyRuleApi = param => {
  const params = {
    Api: 'deleteAutoReplyRule',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 更新自动回复规则
export const updateAutoReplyRuleApi = param => {
  const params = {
    Api: 'updateAutoReplyRule',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 根据id获取自动回复规则
export const getAutoReplyRuleByIdApi = param => {
  const params = {
    Api: 'getAutoReplyRuleById',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询自动回复规则
export const queryAutoReplyRuleApi = param => {
  const params = {
    Api: 'queryAutoReplyRule',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 查询客服消息条目
export const queryCustServiceMsgItemApi = param => {
  const params = {
    Api: 'queryCustServiceMsgItem',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 添加高校快递代取配置
export const addExpressConfigApi = param => {
  const params = {
    Api: 'addExpressConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除高校快递代取配置
export const deleteExpressConfigApi = param => {
  const params = {
    Api: 'deleteExpressConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置高校快递代取配置置顶
export const setExpressConfigTopApi = param => {
  const params = {
    Api: 'setExpressConfigTop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询高校快递代取配置列表
export const queryExpressConfigListApi = param => {
  const params = {
    Api: 'queryExpressConfigList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询代取快递列表
export const queryExpressListApi = param => {
  const params = {
    Api: 'queryExpressList',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 订单作废
export const cancleOrderApi = param => {
  const params = {
    Api: 'cancleOrder',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 根据id获取集团信息
export const getGroupByIdApi = param => {
  const params = {
    Api: 'getGroupById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置商品是否推荐
export const setGoodsIsRecomApi = param => {
  const params = {
    Api: 'setGoodsIsRecom',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 添加楼栋
export const addBuildingApi = param => {
  const params = {
    Api: 'addBuilding',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除楼栋
export const deleteBuildingApi = param => {
  const params = {
    Api: 'deleteBuilding',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置楼栋信息
export const setBuildingMsgApi = param => {
  const params = {
    Api: 'setBuildingMsg',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取楼栋列表
export const getBuildingListApi = param => {
  const params = {
    Api: 'getBuildingList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询高校外卖模式后台首页
export const queryGxHomePageApi = param => {
  const params = {
    Api: 'queryGxHomePage',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 提现申请——高校
export const applyForWithdrawalCommonApi = param => {
  const params = {
    Api: 'applyForWithdrawalCommon',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置店长规则
export const setShopownerRuleApi = param => {
  const params = {
    Api: 'setShopownerRule',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加店长
export const addShopownerApi = param => {
  const params = {
    Api: 'addShopowner',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 删除店长
export const deleteShopownerApi = param => {
  const params = {
    Api: 'deleteShopowner',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 添加店长关联门店
export const addShopownerRelShopApi = param => {
  const params = {
    Api: 'addShopownerRelShop',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询店长
export const queryShopownerApi = param => {
  const params = {
    Api: 'queryShopowner',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询店长关联门店
export const queryShopownerRelShopApi = param => {
  const params = {
    Api: 'queryShopownerRelShop',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 获取店长关联门店列表
export const getShopownerRelShopListApi = param => {
  const params = {
    Api: 'getShopownerRelShopList',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 新增/更新奖金池配置
export const saveOrUpdateBonusPoolConfigApi = param => {
  const params = {
    Api: 'saveOrUpdateBonusPoolConfig',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取品牌奖金池配置
export const getBrandBonusPoolConfigApi = param => {
  const params = {
    Api: 'getBrandBonusPoolConfig',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 更新核销码有效时间
export const updateWriteOffCodeValidTimeApi = param => {
  const params = {
    Api: 'updateWriteOffCodeValidTime',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 设置是否禁言
export const setIsBanWordApi = param => {
  const params = {
    Api: 'setIsBanWord',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询品牌用户分页数据
export const queryBrandUserPageApi = param => {
  const params = {
    Api: 'queryBrandUserPage',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 把打印机添加到飞鹅平台中
export const feieAddPrinterApi = param => {
  const params = {
    Api: 'feieAddPrinter',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取飞鹅打印机状态
export const feieGetPrintStatusApi = param => {
  const params = {
    Api: 'feieGetPrintStatus',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询表白墙举报
export const queryConfessionWallReportApi = param => {
  const params = {
    Api: 'queryConfessionWallReport',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 设置总店
export const setMainShopApi = param => {
  const params = {
    Api: 'setMainShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取高校订单总统计
export const getGxOrderTotalStatisticsApi = param => {
  const params = {
    Api: 'getGxOrderTotalStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询高校订单按天统计
export const queryGxOrderByDayStatisticsApi = param => {
  const params = {
    Api: 'queryGxOrderByDayStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询高校商品销量统计
export const queryGxGoodsSalesStatisticsApi = param => {
  const params = {
    Api: 'queryGxGoodsSalesStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询工作岗位应聘信息
export const queryWorkPostApplicationApi = param => {
  const params = {
    Api: 'queryWorkPostApplication',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置工作岗位应聘审核状态
export const setWorkPostApplicationCheckStateApi = param => {
  const params = {
    Api: 'setWorkPostApplicationCheckState',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置岗位推荐规则配置
export const setPostRecommRuleConfigApi = param => {
  const params = {
    Api: 'setPostRecommRuleConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加企业信息
export const addEnterpriseApi = param => {
  const params = {
    Api: 'addEnterprise',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除企业信息
export const deleteEnterpriseApi = param => {
  const params = {
    Api: 'deleteEnterprise',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新企业信息
export const updateEnterpriseApi = param => {
  const params = {
    Api: 'updateEnterprise',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询企业信息
export const queryEnterpriseApi = param => {
  const params = {
    Api: 'queryEnterprise',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id获取企业信息
export const getEnterpriseByIdApi = param => {
  const params = {
    Api: 'getEnterpriseById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加工作岗位
export const addWorkPostApi = param => {
  const params = {
    Api: 'addWorkPost',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除工作岗位
export const deleteWorkPostApi = param => {
  const params = {
    Api: 'deleteWorkPost',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新工作岗位
export const updateWorkPostApi = param => {
  const params = {
    Api: 'updateWorkPost',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置工作岗位信息
export const setWorkPostMsgApi = param => {
  const params = {
    Api: 'setWorkPostMsg',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id获取工作岗位
export const getWorkPostByIdApi = param => {
  const params = {
    Api: 'getWorkPostById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询工作岗位
export const queryWorkPostApi = param => {
  const params = {
    Api: 'queryWorkPost',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加岗位离职
export const addWorkPostQuitApi = param => {
  const params = {
    Api: 'addWorkPostQuit',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询岗位离职
export const queryWorkPostQuitApi = param => {
  const params = {
    Api: 'queryWorkPostQuit',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询工资和分红记录
export const queryWageAndBonusRecordsApi = param => {
  const params = {
    Api: 'queryWageAndBonusRecords',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询用户工作岗位
export const queryUserWorkPostApi = param => {
  const params = {
    Api: 'queryUserWorkPost',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 按门店分组统计高校订单
export const getGxOrderCountGroupByShopApi = param => {
  const params = {
    Api: 'getGxOrderCountGroupByShop',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 按天获取高校订单统计(用于集团)
export const getGxOrderCountByDayForGroupApi = param => {
  const params = {
    Api: 'getGxOrderCountByDayForGroup',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 获取高校商品销量统计
export const getGxGoodsSalesStatisticsApi = param => {
  const params = {
    Api: 'getGxGoodsSalesStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 用户押金调整
export const userDepositAdjustApi = param => {
  const params = {
    Api: 'userDepositAdjust',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 获取用户押金流调整统计
export const getUserDepositAdjustCountListApi = param => {
  const params = {
    Api: 'getUserDepositAdjustCountList',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 查询用户押金调整流水
export const queryUserDepositAdjustWaterApi = param => {
  const params = {
    Api: 'queryUserDepositAdjustWater',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置商品限购规则
export const setGoodsLimitBuyRuleApi = param => {
  const params = {
    Api: 'setGoodsLimitBuyRule',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 设置用户限购调整
export const setUserLimitBuyAdjustApi = param => {
  const params = {
    Api: 'setUserLimitBuyAdjust',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询用户限购调整记录
export const queryUserLimitBuyAdjustApi = param => {
  const params = {
    Api: 'queryUserLimitBuyAdjust',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 获取限购商品id集
export const getLimitBuyGoodsIdsApi = param => {
  const params = {
    Api: 'getLimitBuyGoodsIds',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 分页查询服务商
export const queryHftxFwsApi = param => {
  const params = {
    Api: 'queryHftxFws',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询商家后台吉祥天首页统计
export const getJxtHomePageStatisticsApi = param => {
  const params = {
    Api: 'getJxtHomePageStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 条件配送相关接口
export const queryOrderErrandFloorConfigApi = param => {
  const params = {
    Api: 'queryOrderErrandFloorConfig',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 条件配送相关接口
export const queryOrderErrandFloorConfig2Api = param => {
  const params = {
    Api: 'queryOrderErrandFloorConfig2',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 添加中转篮子
export const addErrandBasketApi = param => {
  const params = {
    Api: 'addErrandBasket',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改中转篮子
export const updateErrandBasketApi = param => {
  const params = {
    Api: 'updateErrandBasket',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除中转篮子
export const deleteErrandBasketApi = param => {
  const params = {
    Api: 'deleteErrandBasket',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询中转篮子
export const queryErrandBasketApi = param => {
  const params = {
    Api: 'queryErrandBasket',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 批量完成订单
export const gxBatchOrderCompletionApi = param => {
  const params = {
    Api: 'gxBatchOrderCompletion',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 回复门店评价
export const updateOrderEvaluateApi = param => {
  const params = {
    Api: 'updateOrderEvaluate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 新增评价
export const submitOrderEvaluationApi = param => {
  const params = {
    Api: 'submitOrderEvaluation',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 复制店铺装修页面
export const copyMiniMenuApi = param => {
  const params = {
    Api: 'copyMiniMenu',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询支付宝信息
export const queryAliPersonalAccountApi = param => {
  const params = {
    Api: 'queryAliPersonalAccount',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 新增/更新支付宝账户信息
export const saveOrUpdateAliPersonalAccountApi = param => {
  const params = {
    Api: 'saveOrUpdateAliPersonalAccount',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加商品搭售分组
export const addGoodsTyingGroupApi = param => {
  const params = {
    Api: 'addGoodsTyingGroup',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 删除商品搭售分组
export const deleteGoodsTyingGroupApi = param => {
  const params = {
    Api: 'deleteGoodsTyingGroup',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 更新商品搭售分组
export const updateGoodsTyingGroupApi = param => {
  const params = {
    Api: 'updateGoodsTyingGroup',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询商品搭售分组
export const queryGoodsTyingGroupApi = param => {
  const params = {
    Api: 'queryGoodsTyingGroup',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 获取商品搭售分组列表
export const getGoodsTyingGroupListApi = param => {
  const params = {
    Api: 'getGoodsTyingGroupList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 根据商品id获取商品关联的搭售分组列表
export const getGoodsTyingGroupRelListByGoodsIdApi = param => {
  const params = {
    Api: 'getGoodsTyingGroupRelListByGoodsId',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询订单霸王任务
export const queryOrderOverlordTaskApi = param => {
  const params = {
    Api: 'queryOrderOverlordTask',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 审核订单霸王任务
export const checkOrderOverlordTaskApi = param => {
  const params = {
    Api: 'checkOrderOverlordTask',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 根据id获取询订单霸王任务
export const getOrderOverlordTaskByIdApi = param => {
  const params = {
    Api: 'getOrderOverlordTaskById',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询门店霸王余额流水
export const queryShopOverlordBalanceWaterApi = param => {
  const params = {
    Api: 'queryShopOverlordBalanceWater',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取霸王餐门店对应列表
export const queryShopOverlordMealListApi = param => {
  const params = {
    Api: 'queryShopOverlordMealList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置霸王餐活动
export const setShopOverlordMealTaskApi = param => {
  const params = {
    Api: 'setShopOverlordMealTask',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取霸王任务统计
export const getOverlordTaskStatisticsForPlatApi = param => {
  const params = {
    Api: 'getOverlordTaskStatisticsForPlat',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 获取员工列表信息(用于平台)
export const getStaffListForPlatApi = param => {
  const params = {
    Api: 'getStaffListForPlat',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 新增/更新淘宝账号信息
export const saveOrUpdateTbkInfoApi = param => {
  const params = {
    Api: 'saveOrUpdateTbkInfo',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据外键（品牌）id获取淘宝客信息
export const getTbkInfoByForeignKeyIdApi = param => {
  const params = {
    Api: 'getTbkInfoByForeignKeyId',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 饿了么pid查询
export const queryElmPidsApi = param => {
  const params = {
    Api: 'queryElmPids',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 饿了么pid导入
export const exportElmPidsApi = param => {
  const params = {
    Api: 'exportElmPids',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 添加微信关联通知绑定
export const addWechatRelationNoticeBindApi = param => {
  const params = {
    Api: 'addWechatRelationNoticeBind',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 删除微信关联通知绑定
export const deleteWechatRelationNoticeBindApi = param => {
  const params = {
    Api: 'deleteWechatRelationNoticeBind',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 查询微信关联通知绑定信息
export const queryWechatRelationNoticeBindApi = param => {
  const params = {
    Api: 'queryWechatRelationNoticeBind',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// cps配置信息查询
export const queryTakeoutConfigApi = param => {
  const params = {
    Api: 'queryTakeoutConfig',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 批量拷贝门店商品
export const batchCopyShopGoodsApi = param => {
  const params = {
    Api: 'batchCopyShopGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询用户站点变更申请
export const queryUserSiteChangeApplyApi = param => {
  const params = {
    Api: 'queryUserSiteChangeApply',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 审核用户站点变更申请
export const checkUserSiteChangeApplyApi = param => {
  const params = {
    Api: 'checkUserSiteChangeApply',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置公司扩展配置(json对象)
export const setCompanyExtendConfigApi = param => {
  const params = {
    Api: 'setCompanyExtendConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 易联云打印机声音调节
export const ylyPrintSetSoundApi = param => {
  const params = {
    Api: 'ylyPrintSetSound',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取关键词屏蔽配置
export const getKeywordShieldConfigApi = param => {
  const params = {
    Api: 'getKeywordShieldConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加关键词屏蔽配置
export const saveKeywordShieldConfigApi = param => {
  const params = {
    Api: 'saveKeywordShieldConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除品牌关联共享门店
export const deleteBrandRelShareShopApi = param => {
  const params = {
    Api: 'deleteBrandRelShareShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 渠道id新增与更新接口
export const saveOrUpdateTbkRelationIdApi = param => {
  const params = {
    Api: 'saveOrUpdateTbkRelationId',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询渠道关系id
export const queryTbkRelationIdsApi = param => {
  const params = {
    Api: 'queryTbkRelationIds',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 新增/更新渠道专属pid
export const saveOrUpdateTbkPidApi = param => {
  const params = {
    Api: 'saveOrUpdateTbkPid',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询推广位
export const queryTbkPidsApi = param => {
  const params = {
    Api: 'queryTbkPids',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 新增/更新海报接口
export const saveOrUpdatePosterApi = param => {
  const params = {
    Api: 'saveOrUpdatePoster',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id删除海报接口
export const delPosterByIdApi = param => {
  const params = {
    Api: 'delPosterById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询海报接口
export const queryPostersApi = param => {
  const params = {
    Api: 'queryPosters',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询自定义表单数据
export const queryBrandUserFormApi = param => {
  const params = {
    Api: 'queryBrandUserForm',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id删除供应商
export const deleteSupplierByIdApi = param => {
  const params = {
    Api: 'deleteSupplierById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id删除供应商门店
export const deleteSupplierShopByIdApi = param => {
  const params = {
    Api: 'deleteSupplierShopById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加用户等级升级规则
export const addUserGradeUpgradeRuleApi = param => {
  const params = {
    Api: 'addUserGradeUpgradeRule',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 删除用户等级升级规则
export const deleteUserGradeUpgradeRuleApi = param => {
  const params = {
    Api: 'deleteUserGradeUpgradeRule',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 修改用户等级升级规则
export const updateUserGradeUpgradeRuleApi = param => {
  const params = {
    Api: 'updateUserGradeUpgradeRule',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 根据id获取用户等级升级规则
export const getUserGradeUpgradeRuleByIdApi = param => {
  const params = {
    Api: 'getUserGradeUpgradeRuleById',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 查询用户等级升级规则
export const queryUserGradeUpgradeRuleApi = param => {
  const params = {
    Api: 'queryUserGradeUpgradeRule',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置用户等级升级规则
export const setUserGradeUpgradeRuleMsgApi = param => {
  const params = {
    Api: 'setUserGradeUpgradeRuleMsg',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 新增或者更新配置信息
export const saveOrUpdateBwcConfigApi = param => {
  const params = {
    Api: 'saveOrUpdateBwcConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 配置查询
export const queryBwcConfigApi = param => {
  const params = {
    Api: 'queryBwcConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询微信通知绑定列表信息
export const queryWechatNoticeBindApi = param => {
  const params = {
    Api: 'queryWechatNoticeBind',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 添加微信通知绑定(用于品牌)
export const addWechatNoticeBindForCompanyApi = param => {
  const params = {
    Api: 'addWechatNoticeBindForCompany',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 添加微信通知绑定(用于公司)
export const addWechatNoticeBindForBrandApi = param => {
  const params = {
    Api: 'addWechatNoticeBindForBrand',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 打印
export const printOrderApi = param => {
  const params = {
    Api: 'printOrder',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 更新订单显示状态
export const updateMiniAppShowStatusApi = param => {
  const params = {
    Api: 'updateMiniAppShowStatus',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 设置品牌用户信息
export const setBrandUserMsgApi = param => {
  const params = {
    Api: 'setBrandUserMsg',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// 设置品牌自定义字段信息
export const setBrandCustomConfigFieldMsgApi = param => {
  const params = {
    Api: 'setBrandCustomConfigFieldMsg',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取高校公司收益统计
export const getGxCompanyProfitStatisticsApi = param => {
  const params = {
    Api: 'getGxCompanyProfitStatistics',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 删除表白墙评论
export const deleConfessionWallEvaluateApi = param => {
  const params = {
    Api: 'deleConfessionWallEvaluate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 设置自定义表单信息
export const setFormTableMsgApi = param => {
  const params = {
    Api: 'setFormTableMsg',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取门店初始员工账号
export const getShopInitStaffAccountApi = param => {
  const params = {
    Api: 'getShopInitStaffAccount',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
// 查询用户高校订单
export const queryUserGxOrderApi = param => {
  const params = {
    Api: 'queryUserGxOrder',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询零食盒子商品销售排行
export const querySnackBoxGoodsSalesRankingApi = param => {
  const params = {
    Api: 'querySnackBoxGoodsSalesRanking',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 查询公司订单和储备金流水
export const queryCompanyOrderAndReserveFundWaterApi = param => {
  const params = {
    Api: 'queryCompanyOrderAndReserveFundWater',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 公司订单和储备金流水统计
export const getCompanyOrderAndReserveFundWaterCountApi = param => {
  const params = {
    Api: 'getCompanyOrderAndReserveFundWaterCount',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加门店霸王余额
export const addShopOverlordBalanceApi = param => {
  const params = {
    Api: 'addShopOverlordBalance',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}

/** *************************** xsd end ************************** **/
// 根据筛选条件获取人数
export const getMarketingActivityMembersImproveApi = param => {
  const params = {
    Api: 'getMarketingActivityMembersImprove',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 查询满额减列表
export const queryMejmActivityApi = param => {
  const params = {
    Api: 'queryMejmActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 添加满额减活动
export const addMejmActivityApi = param => {
  const params = {
    Api: 'addMejmActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 根据id获取满额减活动详情
export const getMejmActivityByIdApi = param => {
  const params = {
    Api: 'getMejmActivityById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 获取所有的小程序装修内容
export const getAllMiniMenusApi = param => {
  const params = {
    Api: 'getAllMiniMenus',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取微信小程序直播间列表
export const getWxAppLiveRoomListApi = param => {
  const params = {
    Api: 'getWxAppLiveRoomList',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// 获取[社区首页]数据
export const getSqsyMenuApi = param => {
  const params = {
    Api: 'getSqsyMenu',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 更新小程序菜单
export const updateMiniMenuApi = param => {
  const params = {
    Api: 'updateMiniMenu',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除小程序菜单
export const deleteMiniMenuApi = param => {
  const params = {
    Api: 'deleteMiniMenu',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加小程序菜单
export const addMiniMenuApi = param => {
  const params = {
    Api: 'addMiniMenu',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 小程序排序
export const exchangeMiniMenuSortNumApi = param => {
  const params = {
    Api: 'exchangeMiniMenuSortNum',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改公司对象中的companyConfig
export const setCompanyConfigApi = param => {
  const params = {
    Api: 'setCompanyConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询门店信息
export const queryShopsGxApi = param => {
  const params = {
    Api: 'queryShopsGx',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 外卖活动查询
export const queryTakeoutActivitiesApi = param => {
  const params = {
    Api: 'queryTakeoutActivities',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
// 零食盒子
// 添加零食盒子商品
export const addSnackBoxGoodsApi = param => {
  const params = {
    Api: 'addSnackBoxGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 修改零食盒子商品
export const updateSnackBoxGoodsApi = param => {
  const params = {
    Api: 'updateSnackBoxGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 修改零食盒子商品信息(不改库存)
export const updateSnackBoxGoodsMsgApi = param => {
  const params = {
    Api: 'updateSnackBoxGoodsMsg',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 设置零食盒子商品是否上架
export const setSnackBoxGoodsIsShelvesApi = param => {
  const params = {
    Api: 'setSnackBoxGoodsIsShelves',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 根据id获取零食盒子商品
export const getSnackBoxGoodsByIdApi = param => {
  const params = {
    Api: 'getSnackBoxGoodsById',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 获取零食盒子商品列表
export const getSnackBoxGoodsListApi = param => {
  const params = {
    Api: 'getSnackBoxGoodsList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询零食盒子商品
export const querySnackBoxGoodsApi = param => {
  const params = {
    Api: 'querySnackBoxGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 添加零食盒子分类
export const addSnackBoxTypeApi = param => {
  const params = {
    Api: 'addSnackBoxType',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除零食盒子分类
export const deleteSnackBoxTypeApi = param => {
  const params = {
    Api: 'deleteSnackBoxType',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改零食盒子分类
export const updateSnackBoxTypeApi = param => {
  const params = {
    Api: 'updateSnackBoxType',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 获取零食盒子分类列表
export const getSnackBoxTypeListApi = param => {
  const params = {
    Api: 'getSnackBoxTypeList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询零食盒子分类
export const querySnackBoxTypeApi = param => {
  const params = {
    Api: 'querySnackBoxType',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加零食盒子门店
export const addSnackBoxShopApi = param => {
  const params = {
    Api: 'addSnackBoxShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 修改零食盒子门店
export const updateSnackBoxShopApi = param => {
  const params = {
    Api: 'updateSnackBoxShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除零食盒子门店
export const deleteSnackBoxShopApi = param => {
  const params = {
    Api: 'deleteSnackBoxShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 根据id获取零食盒子门店
export const getSnackBoxShopByIdApi = param => {
  const params = {
    Api: 'getSnackBoxShopById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 查询零食盒子门店 — 统计规则
export const querySnackBoxShopApi = param => {
  const params = {
    Api: 'querySnackBoxShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 设置零食盒子门店信用分
export const setSnackBoxShopCreditScoreApi = param => {
  const params = {
    Api: 'setSnackBoxShopCreditScore',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加商品补货模板
export const addGoodsRepairTemplateApi = param => {
  const params = {
    Api: 'addGoodsRepairTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 删除商品补货模板
export const deleteGoodsRepairTemplateApi = param => {
  const params = {
    Api: 'deleteGoodsRepairTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 修改商品补货模板条目
export const updateGoodsRepairTemplateItemApi = param => {
  const params = {
    Api: 'updateGoodsRepairTemplateItem',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 获取商品补货模板和条目
export const getGoodsRepairTemplateAndItemApi = param => {
  const params = {
    Api: 'getGoodsRepairTemplateAndItem',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 根据模板配置获取补货模板条目
export const getRepairTemplateItemByTemplateConfigApi = param => {
  const params = {
    Api: 'getRepairTemplateItemByTemplateConfig',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询商品补货模板
export const queryGoodsRepairTemplateApi = param => {
  const params = {
    Api: 'queryGoodsRepairTemplate',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 添加零食盒子商品相关申请
export const addSnackBoxGoodsApplyApi = param => {
  const params = {
    Api: 'addSnackBoxGoodsApply',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询零食盒子商品相关申请
export const querySnackBoxGoodsApplyApi = param => {
  const params = {
    Api: 'querySnackBoxGoodsApply',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 零食盒子商品相关申请条目和sku列表
export const getSnackBoxGoodsApplyItemAndSkuListApi = param => {
  const params = {
    Api: 'getSnackBoxGoodsApplyItemAndSkuList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 设置零食盒子商品相关申请处理状态
export const setSnackBoxGoodsApplyHandleStateApi = param => {
  const params = {
    Api: 'setSnackBoxGoodsApplyHandleState',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 添加零食盒子库存管理
export const addSnackBoxStockManageApi = param => {
  const params = {
    Api: 'addSnackBoxStockManage',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 查询零食盒子库存管理
export const querySnackBoxStockManageApi = param => {
  const params = {
    Api: 'querySnackBoxStockManage',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 获取零食盒子库存管理关联商品列表
export const getSnackBoxStockManageRelGoodsListApi = param => {
  const params = {
    Api: 'getSnackBoxStockManageRelGoodsList',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 保存配送车关联商品
export const saveDeliveryCarRelGoodsApi = param => {
  const params = {
    Api: 'saveDeliveryCarRelGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 保存零食盒子库存管理完成
export const saveSnackBoxStockManageFinishApi = param => {
  const params = {
    Api: 'saveSnackBoxStockManageFinish',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 回收零食盒子全部商品
export const recoverySnackBoxAllGoodsApi = param => {
  const params = {
    Api: 'recoverySnackBoxAllGoods',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 获取零食盒子盘点统计
export const getSnackBoxInventoryCountApi = param => {
  const params = {
    Api: 'getSnackBoxInventoryCount',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 获取零食盒子数据总览
export const getSnackBoxDataOverviewApi = param => {
  const params = {
    Api: 'getSnackBoxDataOverview',
    Params: param
  }
  return axios.request({
    url: 'report_callApi.do',
    data: params
  })
}
// 添加配送价格配置
export const addDeliveryPriceConfigApi = param => {
  const params = {
    Api: 'addDeliveryPriceConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 添加配送价格配置
export const queryDeliveryPriceConfigApi = param => {
  const params = {
    Api: 'queryDeliveryPriceConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除配送价格配置
export const deleteDeliveryPriceConfigApi = param => {
  const params = {
    Api: 'deleteDeliveryPriceConfig',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// 删除零食盒子库存管理
export const deleteSnackBoxStockManageApi = param => {
  const params = {
    Api: 'deleteSnackBoxStockManage',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
// 删除零食盒子商品相关申请
export const deleteSnackBoxGoodsApplyApi = param => {
  const params = {
    Api: 'deleteSnackBoxGoodsApply',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//  获取品牌分类关联列表
export const getBrandCategoryMidListApi = param => {
  const params = {
    Api: 'getBrandCategoryMidList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  小程序请求商品列表
export const getGoodsByGoodsTypeIdApi = param => {
  const params = {
    Api: 'getGoodsByGoodsTypeId',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//  获取当前公司下所有菜单模板列表
export const getCurCompanyAllFunctionTemplateListApi = param => {
  const params = {
    Api: 'getCurCompanyAllFunctionTemplateList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
//  查询门店分销余额
export const queryShopDistriBalanceApi = param => {
  const params = {
    Api: 'queryShopDistriBalance',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  查询门店分销余额流水
export const queryShopDistriBalanceWaterApi = param => {
  const params = {
    Api: 'queryShopDistriBalanceWater',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  调整门店分销余额
export const adjustShopDistriBalanceApi = param => {
  const params = {
    Api: 'adjustShopDistriBalance',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  设置品牌用户标签信息
export const setBrandUserTagApi = param => {
  const params = {
    Api: 'setBrandUserTag',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
// *****************************投诉建议*************************************
//  添加物业公司
export const addPropertyApi = param => {
  const params = {
    Api: 'addProperty',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  根据id获取物业公司
export const getPropertyByIdApi = param => {
  const params = {
    Api: 'getPropertyById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  查询物业公司列表
export const queryPropertyListApi = param => {
  const params = {
    Api: 'queryPropertyList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  修改物业公司
export const updatePropertyApi = param => {
  const params = {
    Api: 'updateProperty',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  删除物业公司
export const deletePropertyApi = param => {
  const params = {
    Api: 'deleteProperty',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  添加物业公司对应单元
export const addPropertyUnitApi = param => {
  const params = {
    Api: 'addPropertyUnit',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  根据id获取物业公司对应单元
export const getPropertyUnitByIdApi = param => {
  const params = {
    Api: 'getPropertyUnitById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  查询物业公司对应单元列表
export const queryPropertyUnitListApi = param => {
  const params = {
    Api: 'queryPropertyUnitList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  修改物业公司对应单元
export const updatePropertyUnitApi = param => {
  const params = {
    Api: 'updatePropertyUnit',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  删除物业公司对应单元
export const deletePropertyUnitApi = param => {
  const params = {
    Api: 'deletePropertyUnit',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  分页查询物业公司自定义表单信息
export const queryPropertyFormTableListApi = param => {
  const params = {
    Api: 'queryPropertyFormTableList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  设置降级规则配置
export const setDownGradeRuleConfigApi = param => {
  const params = {
    Api: 'setDownGradeRuleConfig',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  团队分销配置
export const commonApiApi = param => {
  const params = {
    Api: 'commonApi',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
// ********************************交友start****************************************************************
//  查询用户信息(用于交友)
export const queryUserForJyApi = param => {
  const params = {
    Api: 'queryUserForJy',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  获取用户基础信息(用于交友)
export const getUserBaseInfoForJyApi = param => {
  const params = {
    Api: 'getUserBaseInfoForJy',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  查询用户关注
export const queryUserFollowApi = param => {
  const params = {
    Api: 'queryUserFollow',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  添加用户兴趣
export const addUserInterestApi = param => {
  const params = {
    Api: 'addUserInterest',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  删除用户兴趣
export const deleteUserInterestApi = param => {
  const params = {
    Api: 'deleteUserInterest',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  修改用户兴趣
export const updateUserInterestApi = param => {
  const params = {
    Api: 'updateUserInterest',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  设置用户兴趣排序号
export const setUserInterestSortNumberApi = param => {
  const params = {
    Api: 'setUserInterestSortNumber',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  查询用户兴趣
export const queryUserInterestApi = param => {
  const params = {
    Api: 'queryUserInterest',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  添加话题分类
export const addTopicTypeApi = param => {
  const params = {
    Api: 'addTopicType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  删除话题分类
export const deleteTopicTypeApi = param => {
  const params = {
    Api: 'deleteTopicType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  修改话题分类
export const updateTopicTypeApi = param => {
  const params = {
    Api: 'updateTopicType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  设置话题分类排序号
export const setTopicTypeSortNumberApi = param => {
  const params = {
    Api: 'setTopicTypeSortNumber',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  获取话题分类列表
export const getTopicTypeListApi = param => {
  const params = {
    Api: 'getTopicTypeList',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  查询话题分类
export const queryTopicTypeApi = param => {
  const params = {
    Api: 'queryTopicType',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  添加话题
export const addTopicApi = param => {
  const params = {
    Api: 'addTopic',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  删除话题
export const deleteTopicApi = param => {
  const params = {
    Api: 'deleteTopic',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  修改话题
export const updateTopicApi = param => {
  const params = {
    Api: 'updateTopic',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  设置话题排序号
export const setTopicSortNumberApi = param => {
  const params = {
    Api: 'setTopicSortNumber',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  查询话题
export const queryTopicApi = param => {
  const params = {
    Api: 'queryTopic',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  添加用户动态信息
export const addUserDynamicInfoApi = param => {
  const params = {
    Api: 'addUserDynamicInfo',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  删除用户动态信息
export const deleteUserDynamicInfoApi = param => {
  const params = {
    Api: 'deleteUserDynamicInfo',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  修改用户动态信息
export const updateUserDynamicInfoApi = param => {
  const params = {
    Api: 'updateUserDynamicInfo',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  设置用户动态信息审核状态
export const setUserDynamicInfoCheckStateApi = param => {
  const params = {
    Api: 'setUserDynamicInfoCheckState',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  查询用户动态信息
export const queryUserDynamicInfoApi = param => {
  const params = {
    Api: 'queryUserDynamicInfo',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  查询用户动态信息
export const queryUserDynamicPraiseApi = param => {
  const params = {
    Api: 'queryUserDynamicPraise',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  删除用户动态点赞
export const deleteUserDynamicPraiseApi = param => {
  const params = {
    Api: 'deleteUserDynamicPraise',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  查询用户动态信息评论
export const queryUserDynamicEvaluateApi = param => {
  const params = {
    Api: 'queryUserDynamicEvaluate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  设置用户动态信息评论是否有效
export const setUserDynamicEvaluateIsValidApi = param => {
  const params = {
    Api: 'setUserDynamicEvaluateIsValid',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  删除用户动态信息评论
export const deleteUserDynamicEvaluateApi = param => {
  const params = {
    Api: 'deleteUserDynamicEvaluate',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  添加投诉分类
export const addComplaintCategoryApi = param => {
  const params = {
    Api: 'addComplaintCategory',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  删除投诉分类
export const deleteComplaintCategoryApi = param => {
  const params = {
    Api: 'deleteComplaintCategory',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  修改投诉分类
export const updateComplaintCategoryApi = param => {
  const params = {
    Api: 'updateComplaintCategory',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  设置投诉分类排序号
export const setComplaintCategorySortNumberApi = param => {
  const params = {
    Api: 'setComplaintCategorySortNumber',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  获取投诉分类列表
export const getComplaintCategoryListApi = param => {
  const params = {
    Api: 'getComplaintCategoryList',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  查询投诉分类
export const queryComplaintCategoryApi = param => {
  const params = {
    Api: 'queryComplaintCategory',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  添加投诉
export const addComplaintApi = param => {
  const params = {
    Api: 'addComplaint',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  删除投诉
export const deleteComplaintApi = param => {
  const params = {
    Api: 'deleteComplaint',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  设置投诉处理状态
export const setComplaintHandleStateApi = param => {
  const params = {
    Api: 'setComplaintHandleState',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  查询投诉
export const queryComplaintApi = param => {
  const params = {
    Api: 'queryComplaint',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  设置用户信息
export const setUserMsgApi = param => {
  const params = {
    Api: 'setUserMsg',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  添加微信广告配置
export const saveWechatAdConfigApi = param => {
  const params = {
    Api: 'saveWechatAdConfig',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
//  获取微信广告配置列表
export const getWechatAdConfigListApi = param => {
  const params = {
    Api: 'getWechatAdConfigList',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
// ********************************交友 END****************************************************************
//  设置公司信息
export const setCompanyMsgApi = param => {
  const params = {
    Api: 'setCompanyMsg',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  添加公司公告
export const addCompanyNoticeApi = param => {
  const params = {
    Api: 'addCompanyNotice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  修改公司公告
export const updateCompanyNoticeApi = param => {
  const params = {
    Api: 'updateCompanyNotice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  根据条件获取公司广告
export const getCompanyNoticeApi = param => {
  const params = {
    Api: 'getCompanyNotice',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  根据id获取公司公告
export const getCompanyNoticeByIdApi = param => {
  const params = {
    Api: 'getCompanyNoticeById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  调整站点运营考核分
export const adjustSiteExamineScoreApi = param => {
  const params = {
    Api: 'adjustSiteExamineScore',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  查询站点考核分流水
export const querySiteExamineScoreWaterApi = param => {
  const params = {
    Api: 'querySiteExamineScoreWater',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  设置站点考核日期
export const setSiteExamineDateApi = param => {
  const params = {
    Api: 'setSiteExamineDate',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  查询品牌站点考核
export const queryBrandSiteExamineApi = param => {
  const params = {
    Api: 'queryBrandSiteExamine',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  basic 公用
export const basicCommonApi = param => {
  const params = {
    Api: 'commonApi',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  添加活动项目
export const addActivityProjectApi = param => {
  const params = {
    Api: 'addActivityProject',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  删除活动项目
export const deleteActivityProjectApi = param => {
  const params = {
    Api: 'deleteActivityProject',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  修改活动项目
export const updateActivityProjectApi = param => {
  const params = {
    Api: 'updateActivityProject',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取活动项目列表
export const getActivityProjectListApi = param => {
  const params = {
    Api: 'getActivityProjectList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询活动项目
export const queryActivityProjectApi = param => {
  const params = {
    Api: 'queryActivityProject',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  添加活动赛事
export const addActivityMatchApi = param => {
  const params = {
    Api: 'addActivityMatch',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  删除活动赛事
export const deleteActivityMatchApi = param => {
  const params = {
    Api: 'deleteActivityMatch',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  修改活动赛事
export const updateActivityMatchApi = param => {
  const params = {
    Api: 'updateActivityMatch',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  设置活动赛事是否有效
export const setActivityMatchIsValidApi = param => {
  const params = {
    Api: 'setActivityMatchIsValid',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  设置活动赛事管理员
export const setActivityMatchAdminApi = param => {
  const params = {
    Api: 'setActivityMatchAdmin',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  根据id获取活动赛事
export const getActivityMatchByIdApi = param => {
  const params = {
    Api: 'getActivityMatchById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取活动赛事列表
export const getActivityMatchListApi = param => {
  const params = {
    Api: 'getActivityMatchList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询活动赛事
export const queryActivityMatchApi = param => {
  const params = {
    Api: 'queryActivityMatch',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询活动赛事(用于小程序)
export const queryActivityMatchForMpApi = param => {
  const params = {
    Api: 'queryActivityMatchForMp',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询我的活动赛事
export const queryMyActivityMatchApi = param => {
  const params = {
    Api: 'queryMyActivityMatch',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  添加活动赛事参与队伍(创建队伍)【队伍人数大于1的创建队伍、战队报名、队伍人数为1的报名】
export const addActivityMatchPartakeRanksApi = param => {
  const params = {
    Api: 'addActivityMatchPartakeRanks',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  删除活动赛事参与队伍
export const deleteActivityMatchPartakeRanksApi = param => {
  const params = {
    Api: 'deleteActivityMatchPartakeRanks',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取活动赛事参与队伍列表
export const getActivityMatchPartakeRanksListApi = param => {
  const params = {
    Api: 'getActivityMatchPartakeRanksList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询活动赛事参与队伍
export const queryActivityMatchPartakeRanksApi = param => {
  const params = {
    Api: 'queryActivityMatchPartakeRanks',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询活动赛事参与队伍和用户
export const queryActivityMatchPartakeRanksAndUserApi = param => {
  const params = {
    Api: 'queryActivityMatchPartakeRanksAndUser',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  添加活动赛事参与用户【直接报名活动，选择战队报名】
export const addActivityMatchPartakeUserApi = param => {
  const params = {
    Api: 'addActivityMatchPartakeUser',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  删除活动赛事参与用户
export const deleteActivityMatchPartakeUserApi = param => {
  const params = {
    Api: 'deleteActivityMatchPartakeUser',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取活动赛事参与用户列表
export const getActivityMatchPartakeUserListApi = param => {
  const params = {
    Api: 'getActivityMatchPartakeUserList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询活动赛事参与用户
export const queryActivityMatchPartakeUserApi = param => {
  const params = {
    Api: 'queryActivityMatchPartakeUser',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  添加活动赛事轮次
export const addActivityMatchRoundApi = param => {
  const params = {
    Api: 'addActivityMatchRound',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  删除活动赛事轮次
export const deleteActivityMatchRoundApi = param => {
  const params = {
    Api: 'deleteActivityMatchRound',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  设置活动赛事进程名称(轮次/场次名称)
export const setActivityMatchProcessNameApi = param => {
  const params = {
    Api: 'setActivityMatchProcessName',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取活动赛事轮次列表
export const getActivityMatchRoundListApi = param => {
  const params = {
    Api: 'getActivityMatchRoundList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  添加活动赛事场次对战
export const addActivityMatchSiteBattleApi = param => {
  const params = {
    Api: 'addActivityMatchSiteBattle',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  删除活动赛事场次对战
export const deleteActivityMatchSiteBattleApi = param => {
  const params = {
    Api: 'deleteActivityMatchSiteBattle',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  设置活动赛事场次对战结果
export const setActivityMatchBattleResultApi = param => {
  const params = {
    Api: 'setActivityMatchBattleResult',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取活动赛事场次和对战队伍列表
export const getActivityMatchSiteAndBattleRanksListApi = param => {
  const params = {
    Api: 'getActivityMatchSiteAndBattleRanksList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取可选战队伍列表
export const getCanSelectBattleRanksListApi = param => {
  const params = {
    Api: 'getCanSelectBattleRanksList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取自定义表单列表
export const getFormTableListApi = param => {
  const params = {
    Api: 'getFormTableList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  获取用户表单数据列表
export const getBrandUserFormListApi = param => {
  const params = {
    Api: 'getBrandUserFormList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  添加用户战队
export const addUserWarbandApi = param => {
  const params = {
    Api: 'addUserWarband',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  删除用户战队
export const deleteUserWarbandApi = param => {
  const params = {
    Api: 'deleteUserWarband',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  设置用户战队信息
export const setUserWarbandMsgApi = param => {
  const params = {
    Api: 'setUserWarbandMsg',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  设置用户战队是否确认认证通知
export const setUserWarbandIsConfirmAuthNoticeApi = param => {
  const params = {
    Api: 'setUserWarbandIsConfirmAuthNotice',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  转让战队队长
export const turnToUserWarbandCaptainApi = param => {
  const params = {
    Api: 'turnToUserWarbandCaptain',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  根据id获取用户战队
export const getUserWarbandByIdApi = param => {
  const params = {
    Api: 'getUserWarbandById',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  根据品牌用户id获取用户战队
export const getUserWarbandByBrandUserIdApi = param => {
  const params = {
    Api: 'getUserWarbandByBrandUserId',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  查询用户战队
export const queryUserWarbandApi = param => {
  const params = {
    Api: 'queryUserWarband',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  添加用户战队成员
export const addUserWarbandMemberApi = param => {
  const params = {
    Api: 'addUserWarbandMember',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  删除用户战队成员
export const deleteUserWarbandMemberApi = param => {
  const params = {
    Api: 'deleteUserWarbandMember',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  退出用户战队
export const outUserWarbandApi = param => {
  const params = {
    Api: 'outUserWarband',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  设置确认退出战队通知
export const setConfirmOutUserWarbandNoticeApi = param => {
  const params = {
    Api: 'setConfirmOutUserWarbandNotice',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  获取用户战队成员列表
export const getUserWarbandMemberListApi = param => {
  const params = {
    Api: 'getUserWarbandMemberList',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  设置用户战队名称
export const setUserWarbandNameApi = param => {
  const params = {
    Api: 'setUserWarbandName',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  添加自定义收费项目
export const addCustomChargeItemApi = param => {
  const params = {
    Api: 'addCustomChargeItem',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  删除自定义收费项目
export const deleteCustomChargeItemApi = param => {
  const params = {
    Api: 'deleteCustomChargeItem',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  修改自定义收费项目
export const updateCustomChargeItemApi = param => {
  const params = {
    Api: 'updateCustomChargeItem',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  设置自定义收费项目排序号
export const setCustomChargeItemSortNumberApi = param => {
  const params = {
    Api: 'setCustomChargeItemSortNumber',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  获取自定义收费项目列表
export const getCustomChargeItemListApi = param => {
  const params = {
    Api: 'getCustomChargeItemList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  保存自定义收费项目关联表
export const saveCustomChargeItemRelApi = param => {
  const params = {
    Api: 'saveCustomChargeItemRel',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  查询停车场订单
export const queryParkingOrderApi = param => {
  const params = {
    Api: 'queryParkingOrder',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  保存停车管理配置和协议
export const saveParkingConfigAndTreatyApi = param => {
  const params = {
    Api: 'saveParkingConfigAndTreaty',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  保存停车管理配置和协议
export const getOrderUserAddressApi = param => {
  const params = {
    Api: 'getOrderUserAddress',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  添加订单信息(用于高校站点)
export const addOrderBeanForGxSiteApi = param => {
  const params = {
    Api: 'addOrderBeanForGxSite',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  获取活动赛事参与队伍统计
export const getActivityMatchPartakeRanksCountApi = param => {
  const params = {
    Api: 'getActivityMatchPartakeRanksCount',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询储备金按天统计记录
export const queryReserveFundDayCountApi = param => {
  const params = {
    Api: 'queryReserveFundDayCount',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  t获取订单其他条目Bean列表
export const getOrderOtherItemBeanListApi = param => {
  const params = {
    Api: 'getOrderOtherItemBeanList',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  查询预约寄件列表
export const querySendExpressListApi = param => {
  const params = {
    Api: 'querySendExpressList',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  查询预约取件列表
export const queryCollectExpressListApi = param => {
  const params = {
    Api: 'queryCollectExpressList',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  员工解绑霸王任务订单
export const staffUnboundOverlordTaskOrderApi = param => {
  const params = {
    Api: 'staffUnboundOverlordTaskOrder',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  获取员工Bean列表信息
export const getStaffBeanListApi = param => {
  const params = {
    Api: 'getStaffBeanList',
    Params: param
  }
  return axios.request({
    url: 'sys_callApi.do',
    data: params
  })
}
//  查询门店对应霸王餐任务日志列表
export const queryShopOverlordMealTaskLogListApi = param => {
  const params = {
    Api: 'queryShopOverlordMealTaskLogList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  门店霸王餐余额清零
export const clearShopOverlordBalanceApi = param => {
  const params = {
    Api: 'clearShopOverlordBalance',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  取消订单霸王任务
export const cancelOrderOverlordTaskApi = param => {
  const params = {
    Api: 'cancelOrderOverlordTask',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  批量添加零食盒子商品相关申请
export const batchAddSnackBoxGoodsApplyApi = param => {
  const params = {
    Api: 'batchAddSnackBoxGoodsApply',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//  批量零食盒子补货出库
export const batchSnackBoxRepairGoodsStockOutApi = param => {
  const params = {
    Api: 'batchSnackBoxRepairGoodsStockOut',
    Params: param
  }
  return axios.request({
    url: 'goods_callApi.do',
    data: params
  })
}
//  获取霸王任务审核记录列表
export const getOverlordTaskCheckRecordListApi = param => {
  const params = {
    Api: 'getOverlordTaskCheckRecordList',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
//  添加连锁品牌
export const addChainBrandApi = param => {
  const params = {
    Api: 'addChainBrand',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  删除连锁品牌
export const deleteChainBrandByIdApi = param => {
  const params = {
    Api: 'deleteChainBrandById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  修改连锁品牌
export const updateChainBrandApi = param => {
  const params = {
    Api: 'updateChainBrand',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  添加连锁品牌关联门店
export const addChainBrandShopApi = param => {
  const params = {
    Api: 'addChainBrandShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  根据id连锁品牌信息
export const getChainBrandByIdApi = param => {
  const params = {
    Api: 'getChainBrandById',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  查询连锁品牌信息
export const queryChainBrandApi = param => {
  const params = {
    Api: 'queryChainBrand',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  生成连锁品牌订单
export const generateOrderApi = param => {
  const params = {
    Api: 'generateOrder',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  霸王餐连锁品牌余额流水
export const queryChainBrandBalanceWaterApi = param => {
  const params = {
    Api: 'queryChainBrandBalanceWater',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  划拨金额到门店
export const transferMoneyToShopApi = param => {
  const params = {
    Api: 'transferMoneyToShop',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  添加微信广告主配置
export const addWechatAdvertiserConfigApi = param => {
  const params = {
    Api: 'addWechatAdvertiserConfig',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
//  更新微信广告主配置
export const updateWechatAdvertiserConfigApi = param => {
  const params = {
    Api: 'updateWechatAdvertiserConfig',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
//  设置微信广告配置是否开启
export const setWechatAdConfigIsOpenApi = param => {
  const params = {
    Api: 'setWechatAdConfigIsOpen',
    Params: param
  }
  return axios.request({
    url: 'wechat_callApi.do',
    data: params
  })
}
//  添加语录
export const addQuotationsApi = param => {
  const params = {
    Api: 'addQuotations',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  删除语录
export const deleteQuotationsApi = param => {
  const params = {
    Api: 'deleteQuotations',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  修改语录
export const updateQuotationsApi = param => {
  const params = {
    Api: 'updateQuotations',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  根据id查询语录
export const getQuotationsByIdApi = param => {
  const params = {
    Api: 'getQuotationsById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询语录列表
export const queryQuotationsApi = param => {
  const params = {
    Api: 'queryQuotations',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  添加海报
export const addPosterApi = param => {
  const params = {
    Api: 'addPoster',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  删除海报
export const deletePosterApi = param => {
  const params = {
    Api: 'deletePoster',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  海报设置
export const setPosterApi = param => {
  const params = {
    Api: 'setPoster',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  根据id查询海报
export const getPosterByIdApi = param => {
  const params = {
    Api: 'getPosterById',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询海报列表
export const queryPosterApi = param => {
  const params = {
    Api: 'queryPoster',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  时效卡设置
export const setGivenPeriodCardConfigApi = param => {
  const params = {
    Api: 'setGivenPeriodCardConfig',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取时效卡设置
export const getGivenPeriodCardConfigApi = param => {
  const params = {
    Api: 'getGivenPeriodCardConfig',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询时效卡流水
export const queryGivenPeriodCardWaterApi = param => {
  const params = {
    Api: 'queryGivenPeriodCardWater',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  赠送时效卡
export const giveGivenPeriodCardApi = param => {
  const params = {
    Api: 'giveGivenPeriodCard',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  添加游戏奖励
export const addGameRewardApi = param => {
  const params = {
    Api: 'addGameReward',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  修改游戏奖励
export const updateGameRewardApi = param => {
  const params = {
    Api: 'updateGameReward',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取游戏奖励
export const getGameRewardApi = param => {
  const params = {
    Api: 'getGameReward',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  添加游戏奖励关联活动
export const addGameRewardRelActivityApi = param => {
  const params = {
    Api: 'addGameRewardRelActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  删除游戏奖励关联活动
export const deleteGameRewardRelActivityApi = param => {
  const params = {
    Api: 'deleteGameRewardRelActivity',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  获取游戏奖励关联活动列表
export const getGameRewardRelActivityListApi = param => {
  const params = {
    Api: 'getGameRewardRelActivityList',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  查询游戏用户
export const queryGameUserApi = param => {
  const params = {
    Api: 'queryGameUser',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  获取当天游戏用户数
export const getCurDayGameUserNumApi = param => {
  const params = {
    Api: 'getCurDayGameUserNum',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  获取当天所有玩游戏人数排行列表
export const getCurDayAllGameUserNumRankingListApi = param => {
  const params = {
    Api: 'getCurDayAllGameUserNumRankingList',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  获取公司关联品牌列表
export const getCompanyRelBrandListApi = param => {
  const params = {
    Api: 'getCompanyRelBrandList',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
//  拒绝退款
export const refuseWithdrawalApi = param => {
  const params = {
    Api: 'refuseWithdrawal',
    Params: param
  }
  return axios.request({
    url: 'activity_callApi.do',
    data: params
  })
}
//  添加提现黑名单
export const addWithdrawBlacklistApi = param => {
  const params = {
    Api: 'addWithdrawBlacklist',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  删除提现黑名单
export const deleteWithdrawBlacklistApi = param => {
  const params = {
    Api: 'deleteWithdrawBlacklist',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  查询提现黑名单
export const queryWithdrawBlacklistApi = param => {
  const params = {
    Api: 'queryWithdrawBlacklist',
    Params: param
  }
  return axios.request({
    url: 'user_callApi.do',
    data: params
  })
}
//  查询语音通知
export const queryVoiceNoticeApi = param => {
  const params = {
    Api: 'queryVoiceNotice',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
//  获取语音通知统计
export const getVoiceNoticeCountApi = param => {
  const params = {
    Api: 'getVoiceNoticeCount',
    Params: param
  }
  return axios.request({
    url: 'msg_callApi.do',
    data: params
  })
}
// 霸王餐开始审核
export const startAuditOrderOverlordTaskApi = param => {
  const params = {
    Api: 'startAuditOrderOverlordTask',
    Params: param
  }
  return axios.request({
    url: 'order_callApi.do',
    data: params
  })
}
// 飞鹅标签打印机设置纸宽度
export const feieSetPrintSizeApi = param => {
  const params = {
    Api: 'feieSetPrintSize',
    Params: param
  }
  return axios.request({
    url: 'basic_callApi.do',
    data: params
  })
}
